// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/fronthomeimage.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #ffffff;
  --soft: #f3f6fd;
  --soft-2: #eef3fb;
  --surface: #ffffff;
  --ink: #08101f;
  --muted: #5e687a;
  --line: #c8d3ea;
  --navy: #112d63;
  --navy-dark: #061126;
  --red: #eb283f;
  --red-dark: #c81f34;
  --red-hover: #f04456;
  --red-deep: #8f1323;
  --yellow: #ffe8a3;
  --shadow: 0 18px 46px rgba(17, 45, 99, 0.12);
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--bg);
  color: var(--ink);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input,
select,
textarea {
  font: inherit;
  letter-spacing: 0;
}

button,
.button {
  align-items: center;
  background: var(--red);
  border: 1px solid var(--red);
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-weight: 900;
  justify-content: center;
  min-height: 46px;
  padding: 12px 18px;
  text-decoration: none;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

button:hover:not(:disabled),
.button:hover {
  background: var(--red-hover);
  border-color: var(--red-hover);
  transform: translateY(-1px);
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.button-light {
  background: #ffffff;
  border-color: var(--line);
  color: var(--navy);
}

.button-light:hover {
  background: var(--soft);
  border-color: var(--line);
  color: var(--navy);
}

label {
  color: var(--ink);
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 800;
  gap: 8px;
}

input,
select,
textarea {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--ink);
  font-weight: 400;
  outline: none;
  padding: 12px 13px;
  width: 100%;
}

input::placeholder,
textarea::placeholder {
  color: #8a94a6;
  font-weight: 400;
}

input:focus,
select:focus,
textarea:focus {
  border-color: var(--red);
  box-shadow: 0 0 0 4px rgba(235, 40, 63, 0.14);
}

textarea {
  resize: vertical;
}

img {
  display: block;
  max-width: 100%;
}

.icon {
  color: currentColor;
  flex: 0 0 auto;
  fill: none;
  height: 18px;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
  width: 18px;
}

button .icon,
.button .icon,
.nav-links .icon {
  height: 16px;
  margin-right: 8px;
  width: 16px;
}

.card-icon {
  background: rgba(235, 40, 63, 0.09);
  border: 1px solid rgba(235, 40, 63, 0.18);
  border-radius: 8px;
  color: var(--red);
  height: 42px;
  margin-bottom: 18px;
  padding: 9px;
  width: 42px;
}

h1,
h2,
h3,
p {
  margin-top: 0;
}

h1 {
  font-size: 58px;
  line-height: 1.04;
  margin-bottom: 18px;
  max-width: 860px;
}

h2 {
  font-size: 38px;
  line-height: 1.12;
  margin-bottom: 12px;
}

h3 {
  font-size: 21px;
  line-height: 1.24;
  margin-bottom: 8px;
}

p {
  color: var(--muted);
  font-size: 16px;
  line-height: 1.65;
}

.site-shell {
  min-height: 100vh;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes menuDrop {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes serviceIconFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-4px) scale(1.06);
  }
}

@keyframes documentFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes tickDraw {
  0%,
  14% {
    opacity: 0;
    stroke-dashoffset: 34;
    transform: scale(0.86);
  }
  24%,
  78% {
    opacity: 1;
    stroke-dashoffset: 0;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    stroke-dashoffset: 0;
    transform: scale(1);
  }
}

@keyframes clipboardMotion {
  0%,
  100% {
    transform: translateY(0) rotate(-1deg);
  }
  50% {
    transform: translateY(-5px) rotate(1deg);
  }
}

@keyframes heldPaperMotion {
  0%,
  100% {
    transform: translateY(0) rotate(-1deg);
  }
  50% {
    transform: translateY(-4px) rotate(2deg);
  }
}

.site-header {
  padding-top: 87px;
  position: relative;
  z-index: 30;
}

.header-main {
  align-items: center;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid var(--line);
  display: grid;
  gap: 18px;
  grid-template-columns: auto 1fr auto;
  padding: 16px max(22px, calc((100vw - 1180px) / 2));
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 32;
}

.brand-lockup {
  align-items: center;
  display: flex;
  gap: 12px;
  grid-column: 1;
}

.brand-lockup img {
  height: 54px;
  width: 54px;
}

.brand-lockup strong,
.brand-lockup span {
  display: block;
}

.brand-lockup strong {
  font-size: 22px;
  line-height: 1.1;
}

.brand-lockup span {
  color: var(--muted);
  font-weight: 700;
}

.nav-links,
.header-actions,
.hero-actions,
.admin-header__actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.header-actions {
  grid-column: 3;
  justify-content: flex-end;
}

.language-switch {
  align-items: center;
  background: var(--soft);
  border: 1px solid var(--line);
  border-radius: 8px;
  display: inline-flex;
  gap: 4px;
  margin-bottom: 12px;
  padding: 4px;
}

.language-switch__option {
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--navy);
  font-size: 12px;
  font-weight: 900;
  min-height: 34px;
  padding: 7px 10px;
}

.language-switch__option:hover {
  background: #ffffff;
  border-color: transparent;
  color: var(--navy);
  transform: none;
}

.language-switch__option--active,
.language-switch__option--active:hover {
  background: var(--red);
  color: #ffffff;
}

.menu-toggle {
  display: none;
}

.nav-links {
  background: var(--red);
  justify-content: center;
  padding: 10px max(22px, calc((100vw - 1180px) / 2));
  position: relative;
  z-index: 20;
}

.nav-links button {
  background: transparent;
  border-color: transparent;
  color: #ffffff;
  min-height: 38px;
  padding: 8px 10px;
}

.nav-links button:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.08);
}

.hero {
  background: linear-gradient(180deg, var(--soft), #ffffff);
  display: grid;
  gap: 40px;
  grid-template-columns: minmax(0, 1fr) minmax(380px, 0.82fr);
  margin: 0 auto;
  max-width: 1180px;
  padding: 64px 20px 54px;
}

.badge,
.eyebrow {
  color: var(--red);
  display: inline-flex;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0;
  margin-bottom: 14px;
  text-transform: uppercase;
}

.badge {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--navy);
  padding: 9px 12px;
  text-transform: none;
}

.hero-copy > p {
  font-size: 18px;
  max-width: 760px;
}

.hero-copy,
.hero-media,
.section-heading,
.info-card,
.college-card,
.step-card,
.review-card,
.faq-card,
.contact-grid,
.cta-strip {
  animation: fadeUp 0.55s ease both;
}

.hero-points {
  display: grid;
  gap: 14px;
  margin: 24px 0;
  max-width: 760px;
}

.point {
  align-items: flex-start;
  display: grid;
  gap: 12px;
  grid-template-columns: 50px 1fr;
}

.point > span {
  align-items: center;
  background: rgba(235, 40, 63, 0.1);
  border-radius: 8px;
  color: var(--red);
  display: flex;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.point > span .icon {
  height: 20px;
  width: 20px;
}

.point strong {
  display: block;
  font-size: 19px;
  margin-bottom: 2px;
}

.point p {
  margin-bottom: 0;
}

.trust-row {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 22px;
  max-width: 720px;
}

.trust-row div {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 16px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.trust-row div:hover {
  border-color: rgba(235, 40, 63, 0.34);
  box-shadow: var(--shadow);
  transform: translateY(-3px);
}

.trust-row .icon {
  color: var(--red);
  height: 22px;
  margin-bottom: 10px;
  width: 22px;
}

.trust-row strong,
.trust-row span {
  display: block;
}

.trust-row strong {
  font-size: 24px;
}

.trust-row span {
  color: var(--muted);
  margin-top: 4px;
}

.hero-media {
  align-self: start;
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.hero-media > img {
  aspect-ratio: 16 / 9;
  object-fit: cover;
  width: 100%;
}

.hero-form-panel {
  padding: 22px;
}

.lead-form {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 26px;
}

.lead-form--compact {
  border: 0;
  box-shadow: none;
  padding: 0;
}

.form-heading span {
  color: var(--red);
  display: block;
  font-size: 12px;
  font-weight: 900;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.form-heading h2 {
  font-size: 26px;
  margin-bottom: 4px;
}

.form-heading p,
.privacy-text {
  font-size: 13px;
  margin-bottom: 0;
}

.form-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-status {
  background: var(--soft);
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--navy);
  margin: 0;
  padding: 10px 12px;
}

.form-status--error {
  background: #fff5f7;
  border-color: #ffc2c9;
  color: var(--red-dark);
}

.section-band,
.services-section,
.review-cta-section,
.contact-section,
.site-footer {
  margin: 0 auto;
  max-width: 1180px;
  padding: 70px 20px;
}

.review-cta-section {
  padding-top: 0;
}

.section-muted {
  background: var(--soft);
  max-width: none;
  padding-left: max(20px, calc((100vw - 1180px) / 2));
  padding-right: max(20px, calc((100vw - 1180px) / 2));
}

.section-heading {
  max-width: 780px;
}

.section-heading--center {
  margin: 0 auto 26px;
  text-align: center;
}

.info-grid,
.college-grid,
.review-grid,
.faq-grid {
  display: grid;
  gap: 18px;
  margin-top: 26px;
}

.info-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.info-grid--four {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.college-grid {
  grid-template-columns: 1fr;
}

.review-grid {
  grid-auto-columns: minmax(320px, 390px);
  grid-auto-flow: column;
  grid-template-columns: none;
  overflow-x: auto;
  padding-bottom: 14px;
  scroll-snap-type: x mandatory;
  scrollbar-color: var(--red) var(--soft);
}

.review-grid::-webkit-scrollbar {
  height: 8px;
}

.review-grid::-webkit-scrollbar-track {
  background: var(--soft);
  border-radius: 999px;
}

.review-grid::-webkit-scrollbar-thumb {
  background: var(--red);
  border-radius: 999px;
}

.faq-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.info-card,
.review-card,
.faq-card,
.step-card {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 22px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.review-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(243, 246, 253, 0.88)),
    #ffffff;
  min-height: 340px;
  overflow: hidden;
  padding: 24px;
  position: relative;
  scroll-snap-align: start;
}

.review-card::before {
  color: rgba(235, 40, 63, 0.1);
  content: "\\"";
  font-size: 120px;
  font-weight: 900;
  line-height: 1;
  position: absolute;
  right: 18px;
  top: 2px;
}

.review-card__top {
  align-items: center;
  border-bottom: 1px solid rgba(200, 211, 234, 0.7);
  display: flex;
  gap: 14px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  position: relative;
  z-index: 1;
}

.info-card:hover,
.college-card:hover,
.review-card:hover,
.faq-card:hover,
.step-card:hover {
  border-color: rgba(235, 40, 63, 0.28);
  box-shadow: var(--shadow);
  transform: translateY(-4px);
}

.college-card {
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  display: grid;
  gap: 28px;
  grid-template-columns: minmax(0, 0.92fr) minmax(360px, 1.08fr);
  overflow: hidden;
  padding: 28px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.college-card:hover {
  border-color: rgba(235, 40, 63, 0.28);
  box-shadow: var(--shadow);
  transform: translateY(-4px);
}

.college-card:nth-child(even) .college-card__content {
  order: 2;
}

.college-card:nth-child(even) .college-card__photo {
  order: 1;
}

.college-card__photo {
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  height: 100%;
  max-height: 360px;
  object-fit: cover;
  width: 100%;
}

.college-card__title {
  align-items: center;
  display: grid;
  gap: 14px;
  grid-template-columns: 70px 1fr;
  margin-bottom: 8px;
}

.college-card__title img {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  height: 70px;
  object-fit: contain;
  padding: 8px;
  width: 70px;
}

.college-card h3 {
  color: var(--navy);
  font-size: 32px;
  margin-bottom: 0;
}

.college-fee {
  color: var(--red);
  display: block;
  font-size: 20px;
  margin-bottom: 12px;
}

.info-card p,
.college-card p,
.review-card p,
.faq-card p,
.step-card p {
  margin-bottom: 0;
}

.note {
  border-left: 4px solid var(--red);
  margin: 20px 0 0;
  padding-left: 14px;
}

.step-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 24px;
}

.step-card {
  align-items: flex-start;
  display: grid;
  gap: 16px;
  grid-template-columns: 54px 1fr;
}

.step-card > span {
  align-items: center;
  background: rgba(235, 40, 63, 0.1);
  border-radius: 8px;
  color: var(--red);
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 48px;
  justify-content: center;
}

.step-card > span .icon {
  height: 18px;
  width: 18px;
}

.step-card > span small {
  font-size: 11px;
  font-weight: 900;
}

.documents-section {
  padding-top: 36px;
}

.documents-card {
  align-items: center;
  background: linear-gradient(135deg, #ffffff, var(--soft));
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: var(--shadow);
  display: grid;
  gap: 34px;
  grid-template-columns: minmax(280px, 0.78fr) minmax(0, 1.22fr);
  overflow: hidden;
  padding: 28px;
}

.document-visual {
  align-items: center;
  background: linear-gradient(145deg, var(--navy), #183b7a);
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  min-height: 470px;
  overflow: hidden;
  padding: 28px;
  position: relative;
}

.document-visual::before,
.document-visual::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  content: "";
  height: 180px;
  position: absolute;
  width: 180px;
}

.document-visual::before {
  left: -64px;
  top: -54px;
}

.document-visual::after {
  bottom: -70px;
  right: -58px;
}

.document-pad {
  animation: documentFloat 4.2s ease-in-out infinite;
  max-width: 390px;
  overflow: visible;
  position: relative;
  width: 100%;
  z-index: 2;
}

.document-pad__halo {
  fill: rgba(255, 255, 255, 0.08);
}

.document-pad__halo--two,
.document-pad__halo--three {
  fill: rgba(255, 255, 255, 0.12);
}

.document-pad__shadow {
  fill: rgba(0, 0, 0, 0.18);
}

.document-pad__stack {
  opacity: 0.92;
  transform: rotate(-4deg);
  transform-box: fill-box;
  transform-origin: center;
}

.document-pad__sheet {
  fill: rgba(255, 255, 255, 0.62);
  stroke: rgba(255, 255, 255, 0.36);
  stroke-width: 3;
}

.document-pad__sheet--mid {
  fill: rgba(255, 255, 255, 0.76);
}

.document-pad__fold {
  fill: rgba(17, 45, 99, 0.08);
  stroke: rgba(17, 45, 99, 0.14);
  stroke-width: 3;
}

.document-pad__clipboard {
  animation: clipboardMotion 4.8s ease-in-out infinite;
  filter: drop-shadow(0 26px 34px rgba(0, 0, 0, 0.2));
  transform-box: fill-box;
  transform-origin: center;
}

.document-pad__board {
  fill: url("#padGradient");
  stroke: rgba(255, 255, 255, 0.18);
  stroke-width: 4;
}

.document-pad__paper {
  fill: url("#paperGradient");
  stroke: rgba(17, 45, 99, 0.18);
  stroke-width: 3;
}

.document-pad__clip {
  fill: #d7e0f2;
  stroke: rgba(17, 45, 99, 0.2);
  stroke-width: 3;
}

.document-pad__clip-dot {
  fill: #a8b7d5;
}

.document-pad__box {
  fill: #ffffff;
  stroke: rgba(17, 45, 99, 0.2);
  stroke-width: 2;
}

.document-pad__line {
  fill: none;
  stroke: #9aa9c9;
  stroke-linecap: round;
  stroke-width: 7;
}

.document-pad__line--short {
  opacity: 0.62;
  stroke-width: 5;
}

.document-pad__tick,
.document-pad__seal-check {
  fill: none;
  opacity: 0;
  stroke: var(--red);
  stroke-dasharray: 34;
  stroke-dashoffset: 34;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 6;
  transform-box: fill-box;
  transform-origin: center;
}

.document-pad__tick {
  animation: tickDraw 4.8s ease-in-out infinite;
}

.document-pad__tick--2 {
  animation-delay: 0.45s;
}

.document-pad__tick--3 {
  animation-delay: 0.9s;
}

.document-pad__tick--4 {
  animation-delay: 1.35s;
}

.document-pad__tick--5 {
  animation-delay: 1.8s;
}

.document-pad__seal {
  fill: rgba(235, 40, 63, 0.11);
  stroke: var(--red);
  stroke-width: 7;
}

.document-pad__seal-check {
  animation: tickDraw 4.8s ease-in-out 2.25s infinite;
  stroke-width: 8;
}

.document-character {
  max-width: 390px;
  overflow: visible;
  position: relative;
  width: 100%;
  z-index: 2;
}

.document-character__shadow {
  fill: rgba(0, 0, 0, 0.18);
}

.document-character__clipboard {
  animation: clipboardMotion 4.4s ease-in-out infinite;
  transform-box: fill-box;
  transform-origin: center;
}

.document-character__board {
  fill: #0b234f;
  stroke: rgba(255, 255, 255, 0.18);
  stroke-width: 4;
}

.document-character__paper,
.document-character__held-sheet {
  fill: url("#paperGradient");
  stroke: rgba(17, 45, 99, 0.18);
  stroke-width: 3;
}

.document-character__clip {
  fill: #d7e0f2;
  stroke: rgba(17, 45, 99, 0.2);
  stroke-width: 3;
}

.document-character__clip-dot {
  fill: #a8b7d5;
}

.document-character__line,
.document-character__held-line {
  fill: none;
  stroke: #9aa9c9;
  stroke-linecap: round;
  stroke-width: 6;
}

.document-character__box {
  fill: #ffffff;
  stroke: rgba(17, 45, 99, 0.2);
  stroke-width: 2;
}

.document-character__tick,
.document-character__held-tick {
  fill: none;
  opacity: 0;
  stroke: var(--red);
  stroke-dasharray: 34;
  stroke-dashoffset: 34;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 6;
  transform-box: fill-box;
  transform-origin: center;
}

.document-character__tick {
  animation: tickDraw 4.8s ease-in-out infinite;
}

.document-character__tick--2 {
  animation-delay: 0.45s;
}

.document-character__tick--3 {
  animation-delay: 0.9s;
}

.document-character__tick--4 {
  animation-delay: 1.35s;
}

.document-character__tick--5 {
  animation-delay: 1.8s;
}

.document-character__held-tick {
  animation: tickDraw 4.8s ease-in-out 2.25s infinite;
  stroke-width: 8;
}

.document-character__person {
  animation: documentFloat 4.2s ease-in-out infinite;
  transform-box: fill-box;
  transform-origin: center;
}

.document-character__leg {
  fill: #0d224b;
}

.document-character__leg--right {
  fill: #132e63;
}

.document-character__shoe {
  fill: #061126;
}

.document-character__torso {
  fill: url("#shirtGradient");
}

.document-character__neck,
.document-character__face,
.document-character__hand {
  fill: #f2b08a;
}

.document-character__hair {
  fill: #672f27;
}

.document-character__smile {
  fill: none;
  stroke: #ffffff;
  stroke-linecap: round;
  stroke-width: 4;
}

.document-character__eye {
  fill: #33201d;
}

.document-character__arm,
.document-character__arm--right {
  fill: none;
  stroke: #f2b08a;
  stroke-linecap: round;
  stroke-width: 18;
}

.document-character__arm--right {
  stroke-width: 17;
}

.document-character__held-paper {
  animation: heldPaperMotion 3.4s ease-in-out infinite;
  transform-box: fill-box;
  transform-origin: center;
}

.document-character__held-fold {
  fill: rgba(17, 45, 99, 0.08);
  stroke: rgba(17, 45, 99, 0.14);
  stroke-width: 3;
}

.document-dashboard {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.34);
  border-radius: 8px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
  color: var(--ink);
  max-width: 380px;
  padding: 18px;
  position: relative;
  width: 100%;
  z-index: 2;
}

.document-dashboard__head {
  align-items: center;
  border-bottom: 1px solid var(--line);
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 14px;
}

.document-dashboard__head span,
.document-progress span,
.document-upload-card span {
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
}

.document-dashboard__head strong {
  background: rgba(235, 40, 63, 0.09);
  border-radius: 8px;
  color: var(--red);
  font-size: 12px;
  padding: 7px 9px;
}

.document-upload-card {
  align-items: flex-start;
  background: linear-gradient(135deg, var(--soft), #ffffff);
  border: 1px solid var(--line);
  border-radius: 8px;
  display: grid;
  gap: 12px;
  grid-template-columns: 46px 1fr;
  margin-bottom: 14px;
  padding: 14px;
}

.document-upload-card__icon {
  align-items: center;
  background: var(--navy);
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.document-upload-card__icon .icon {
  height: 24px;
  width: 24px;
}

.document-upload-card strong,
.document-upload-card span {
  display: block;
}

.document-upload-card strong {
  color: var(--navy);
  font-size: 16px;
  line-height: 1.25;
  margin-bottom: 6px;
}

.document-upload-card span {
  line-height: 1.45;
}

.document-progress {
  background: var(--navy-dark);
  border-radius: 8px;
  color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}

.document-progress span,
.document-progress strong {
  display: block;
}

.document-progress span {
  color: rgba(255, 255, 255, 0.7);
}

.document-progress strong {
  color: #ffffff;
  font-size: 15px;
  margin-top: 4px;
}

.document-progress div {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  height: 7px;
  margin-top: 12px;
  overflow: hidden;
}

.document-progress div span {
  background: var(--red);
  border-radius: inherit;
  display: block;
  height: 100%;
  width: 78%;
}

.document-mini-grid {
  display: grid;
  gap: 9px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.document-mini-grid span {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--navy);
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
  min-height: 46px;
  padding: 10px;
}

.document-floating-card {
  align-items: center;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 8px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.18);
  color: #ffffff;
  display: inline-flex;
  font-size: 13px;
  font-weight: 900;
  gap: 8px;
  padding: 11px 13px;
  position: absolute;
  z-index: 3;
}

.document-floating-card .icon {
  color: #ffffff;
  height: 17px;
  width: 17px;
}

.document-floating-card--top {
  right: 22px;
  top: 26px;
}

.document-floating-card--bottom {
  bottom: 26px;
  left: 22px;
}

.document-art {
  max-width: 360px;
  position: relative;
  width: 100%;
  z-index: 1;
}

.document-art__halo {
  fill: rgba(255, 255, 255, 0.08);
}

.document-art__folder-back {
  fill: rgba(255, 255, 255, 0.2);
  stroke: rgba(255, 255, 255, 0.22);
  stroke-width: 3;
}

.document-art__paper {
  fill: #ffffff;
  stroke: rgba(17, 45, 99, 0.18);
  stroke-width: 3;
}

.document-art__paper--one {
  opacity: 0.74;
}

.document-art__paper--two {
  fill: url("#folderGradient");
}

.document-art__fold {
  fill: rgba(17, 45, 99, 0.08);
  stroke: rgba(17, 45, 99, 0.16);
  stroke-width: 3;
}

.document-art__folder-front {
  fill: url("#folderGradient");
  stroke: rgba(255, 255, 255, 0.55);
  stroke-width: 3;
}

.document-art__id-card {
  fill: #ffffff;
  stroke: rgba(17, 45, 99, 0.18);
  stroke-width: 3;
}

.document-art__id-dot {
  fill: rgba(235, 40, 63, 0.16);
}

.document-art__id-line,
.document-art__clip {
  fill: none;
  stroke: #9aa9c9;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 8;
}

.document-art__stamp {
  fill: rgba(235, 40, 63, 0.12);
  stroke: url("#accentGradient");
  stroke-width: 8;
}

.document-art__check {
  fill: none;
  stroke: var(--red);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 10;
}

.document-orbit {
  align-items: center;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.16);
  color: #ffffff;
  display: flex;
  height: 58px;
  justify-content: center;
  position: absolute;
  width: 58px;
  z-index: 3;
}

.document-orbit .icon {
  height: 28px;
  width: 28px;
}

.document-orbit--top {
  right: 28px;
  top: 30px;
}

.document-orbit--bottom {
  bottom: 30px;
  left: 28px;
}

.document-blob {
  fill: rgba(255, 255, 255, 0.08);
}

.document-sheet {
  fill: url("#documentGradient");
  stroke: rgba(17, 45, 99, 0.24);
  stroke-width: 3;
}

.document-sheet--back {
  fill: rgba(255, 255, 255, 0.34);
}

.document-fold {
  fill: #f3f6fd;
  stroke: rgba(17, 45, 99, 0.22);
  stroke-width: 3;
}

.document-line {
  fill: none;
  stroke: #9aa9c9;
  stroke-linecap: round;
  stroke-width: 10;
}

.document-line--title {
  stroke: var(--red);
}

.document-stamp {
  fill: rgba(235, 40, 63, 0.11);
  stroke: var(--red);
  stroke-width: 8;
}

.document-check {
  fill: none;
  stroke: var(--red);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 10;
}

.document-visual__chip {
  align-items: center;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  bottom: 24px;
  display: inline-flex;
  font-weight: 900;
  gap: 8px;
  left: 24px;
  padding: 10px 12px;
  position: absolute;
  z-index: 2;
}

.documents-copy > p {
  max-width: 700px;
}

.document-list {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 22px;
}

.document-list article {
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  display: grid;
  gap: 12px;
  grid-template-columns: 42px 1fr;
  padding: 16px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.document-list article:hover {
  border-color: rgba(235, 40, 63, 0.3);
  box-shadow: 0 14px 34px rgba(17, 45, 99, 0.1);
  transform: translateY(-3px);
}

.document-list article > span {
  align-items: center;
  background: rgba(235, 40, 63, 0.09);
  border-radius: 8px;
  color: var(--red);
  display: flex;
  font-size: 13px;
  font-weight: 900;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.document-list h3 {
  color: var(--navy);
  font-size: 16px;
  margin-bottom: 4px;
}

.document-list p {
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 0;
}

.college-card__meta {
  align-items: center;
  color: var(--red);
  display: flex;
  font-size: 12px;
  font-weight: 900;
  gap: 8px;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.college-card__meta .icon {
  height: 17px;
  width: 17px;
}

.college-card ul,
.trust-box ul {
  color: var(--muted);
  line-height: 1.7;
  margin: 14px 0 18px;
  padding-left: 0;
}

.college-card li,
.trust-box li {
  align-items: flex-start;
  display: flex;
  gap: 8px;
  list-style: none;
  margin-top: 8px;
}

.college-card li .icon,
.trust-box li .icon {
  color: var(--red);
  height: 16px;
  margin-top: 5px;
  width: 16px;
}

.college-card li .icon {
  background: rgba(235, 40, 63, 0.08);
  border-radius: 6px;
  height: 22px;
  margin-top: 2px;
  padding: 4px;
  width: 22px;
}

.college-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.split-section {
  align-items: center;
  display: grid;
  gap: 34px;
  grid-template-columns: minmax(0, 0.9fr) minmax(360px, 0.7fr);
  margin-bottom: 28px;
}

.split-section img,
.trust-box img {
  border-radius: 8px;
  object-fit: cover;
  width: 100%;
}

.photo-stack-section {
  padding-top: 34px;
}

.photo-stack-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 28px;
}

.photo-stack-card {
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--ink);
  display: flex;
  flex-direction: column;
  min-height: 330px;
  overflow: hidden;
  padding: 14px;
  position: relative;
  text-align: left;
}

.photo-stack-card:hover {
  background: var(--red);
  border-color: rgba(235, 40, 63, 0.36);
  box-shadow: var(--shadow);
  color: #ffffff;
  transform: translateY(-4px);
}

.photo-stack-card:hover strong,
.photo-stack-card:hover small {
  color: #ffffff;
}

.photo-stack-card:hover .stack-icon {
  background: #ffffff;
  color: var(--red);
}

.stack-icon {
  align-items: center;
  background: var(--red);
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  height: 44px;
  justify-content: center;
  left: 24px;
  position: absolute;
  top: 24px;
  width: 44px;
  z-index: 2;
}

.stack-icon .icon {
  height: 22px;
  width: 22px;
}

.stack-images {
  display: block;
  height: 184px;
  margin-bottom: 18px;
  position: relative;
  width: 100%;
}

.stack-images img {
  border-radius: 8px;
  height: 150px;
  object-fit: cover;
  position: absolute;
  width: 82%;
}

.stack-images img:first-child {
  left: 0;
  top: 28px;
  z-index: 3;
}

.stack-images img:nth-child(2) {
  left: 10%;
  top: 14px;
  transform: rotate(4deg);
  z-index: 2;
}

.stack-images img:nth-child(3) {
  left: 18%;
  top: 0;
  transform: rotate(8deg);
  z-index: 1;
}

.photo-stack-card strong {
  color: var(--navy);
  display: block;
  font-size: 20px;
  line-height: 1.2;
  margin-bottom: 8px;
}

.photo-stack-card small {
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

.photo-modal {
  background: #ffffff;
  border-radius: 8px;
  max-height: calc(100vh - 40px);
  max-width: 1060px;
  overflow: auto;
  padding: 24px;
  position: relative;
  width: 100%;
}

.photo-modal__head {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  margin-bottom: 18px;
  padding-right: 86px;
}

.photo-gallery {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.photo-gallery figure {
  margin: 0;
}

.photo-gallery img {
  aspect-ratio: 4 / 3;
  border-radius: 8px;
  object-fit: cover;
  width: 100%;
}

.service-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 24px;
}

.service-grid div {
  align-items: flex-start;
  background: var(--navy);
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-weight: 800;
  min-height: 86px;
  padding: 18px;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.service-grid div:hover {
  background: #183b7a;
  transform: translateY(-3px);
}

.service-grid .icon {
  animation: serviceIconFloat 2.4s ease-in-out infinite;
  color: #ffffff;
  height: 42px;
  width: 42px;
}

.service-grid div:nth-child(2n) .icon {
  animation-delay: 0.25s;
}

.service-grid div:nth-child(3n) .icon {
  animation-delay: 0.45s;
}

.cta-strip {
  align-items: center;
  background: var(--navy-dark);
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-top: 22px;
  padding: 24px;
}

.cta-strip h3,
.cta-strip p {
  color: #ffffff;
  margin-bottom: 0;
}

.cta-strip p {
  opacity: 0.82;
}

.review-photo {
  aspect-ratio: 1;
  border: 4px solid #ffffff;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(17, 45, 99, 0.16);
  height: 88px;
  margin-bottom: 0;
  object-fit: cover;
  width: 88px;
}

.review-card strong,
.review-card span {
  display: block;
}

.review-card span {
  color: var(--muted);
  font-size: 13px;
  margin-top: 4px;
}

.review-card p {
  font-size: 15px;
  position: relative;
  z-index: 1;
}

.review-badge {
  align-items: center;
  background: rgba(235, 40, 63, 0.09);
  border: 1px solid rgba(235, 40, 63, 0.16);
  border-radius: 8px;
  color: var(--red);
  display: inline-flex;
  font-size: 12px;
  font-weight: 900;
  gap: 7px;
  margin-top: 20px;
  padding: 8px 10px;
  position: relative;
  z-index: 1;
}

.review-badge .icon {
  height: 14px;
  width: 14px;
}

.contact-section {
  background: var(--soft);
  max-width: none;
  padding-left: max(20px, calc((100vw - 1180px) / 2));
  padding-right: max(20px, calc((100vw - 1180px) / 2));
}

.contact-grid {
  display: grid;
  gap: 22px;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.72fr);
}

.trust-box {
  background: var(--navy-dark);
  border-radius: 8px;
  color: #ffffff;
  padding: 22px;
}

.trust-box h3 {
  color: #ffffff;
  margin-top: 18px;
}

.trust-box li,
.trust-box p {
  color: rgba(255, 255, 255, 0.82);
}

.site-footer {
  background:
    linear-gradient(135deg, rgba(6, 17, 38, 0.94), rgba(17, 45, 99, 0.88)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover;
  color: #ffffff;
  max-width: none;
  padding-left: max(20px, calc((100vw - 1180px) / 2));
  padding-right: max(20px, calc((100vw - 1180px) / 2));
}

.footer-main {
  display: grid;
  gap: 30px;
  grid-template-columns: 1.45fr repeat(3, minmax(0, 1fr));
}

.brand-lockup--footer img {
  background: #ffffff;
  border-radius: 8px;
}

.brand-lockup--footer strong,
.footer-column h3,
.footer-brand p,
.footer-bottom p,
.footer-bottom span {
  color: #ffffff;
}

.brand-lockup--footer span,
.footer-brand p,
.footer-bottom p {
  color: rgba(255, 255, 255, 0.72);
}

.footer-brand p {
  margin: 18px 0;
}

.footer-socials {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.footer-socials a {
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  height: 42px;
  justify-content: center;
  transition: background-color 0.18s ease, transform 0.18s ease;
  width: 42px;
}

.footer-socials a:hover {
  background: var(--red);
  transform: translateY(-2px);
}

.footer-column h3 {
  font-size: 16px;
  margin-bottom: 14px;
}

.footer-column ul {
  display: grid;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-column a {
  color: rgba(255, 255, 255, 0.72);
  font-weight: 500;
  text-decoration: none;
}

.footer-column a:hover {
  color: #ffffff;
}

.footer-contact a {
  align-items: flex-start;
  display: flex;
  gap: 9px;
}

.footer-contact .icon {
  color: var(--red);
  height: 17px;
  margin-top: 2px;
  width: 17px;
}

.footer-map {
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(235, 40, 63, 0.1));
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  display: grid;
  gap: 26px;
  grid-template-columns: minmax(260px, 0.48fr) minmax(520px, 1.52fr);
  margin-top: 42px;
  padding: 22px;
}

.footer-map h3,
.footer-map p {
  color: #ffffff;
}

.footer-map p {
  color: rgba(255, 255, 255, 0.72);
  margin-bottom: 0;
}

.footer-map__text {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-qr {
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  display: flex;
  gap: 14px;
  margin-top: 12px;
  padding: 12px;
}

.footer-qr img {
  background: #ffffff;
  border-radius: 8px;
  height: 104px;
  object-fit: contain;
  padding: 8px;
  width: 104px;
}

.footer-qr strong,
.footer-qr span {
  display: block;
}

.footer-qr strong {
  color: #ffffff;
  font-size: 15px;
}

.footer-qr span {
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  line-height: 1.45;
  margin-top: 4px;
}

.footer-map iframe {
  border: 0;
  border-radius: 8px;
  box-shadow: 0 22px 54px rgba(0, 0, 0, 0.28);
  height: 420px;
  min-height: 420px;
  width: 100%;
}

.footer-bottom {
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-top: 34px;
  padding-top: 22px;
}

.footer-bottom p {
  margin-bottom: 0;
  max-width: 780px;
}

.footer-bottom span {
  flex: 0 0 auto;
  font-weight: 800;
}

.floating-enquiry {
  bottom: 22px;
  box-shadow: var(--shadow);
  position: fixed;
  right: 22px;
  z-index: 20;
}

.floating-enquiry .icon {
  height: 16px;
  width: 16px;
}

.modal-backdrop {
  align-items: center;
  background: rgba(6, 17, 38, 0.66);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 20px;
  position: fixed;
  z-index: 40;
}

.modal {
  background: #ffffff;
  border-radius: 8px;
  max-height: calc(100vh - 40px);
  max-width: 650px;
  overflow: auto;
  padding: 24px;
  position: relative;
  width: 100%;
}

.modal-close {
  background: var(--soft);
  border-color: var(--line);
  color: var(--navy);
  min-height: 36px;
  padding: 7px 10px;
  position: absolute;
  right: 16px;
  top: 16px;
}

.modal-close--icon {
  align-items: center;
  border-radius: 8px;
  display: flex;
  height: 40px;
  justify-content: center;
  min-height: 40px;
  padding: 0;
  width: 40px;
}

.modal-close--icon span {
  background: currentColor;
  border-radius: 999px;
  display: block;
  height: 2px;
  position: absolute;
  width: 18px;
}

.modal-close--icon span:first-child {
  transform: rotate(45deg);
}

.modal-close--icon span:last-child {
  transform: rotate(-45deg);
}

.admin-login {
  align-items: center;
  background: var(--soft);
  display: flex;
  min-height: 100vh;
  padding: 20px;
}

.login-card {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
  max-width: 460px;
  padding: 30px;
  width: 100%;
}

.admin-shell {
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 20px 40px;
}

.admin-header {
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  padding: 26px 0;
}

.admin-header h1 {
  font-size: 42px;
  margin-bottom: 8px;
}

.admin-header p {
  margin-bottom: 0;
}

.summary-strip {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  margin-bottom: 18px;
}

.summary-strip div {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 16px;
}

.summary-strip strong,
.summary-strip span {
  display: block;
}

.summary-strip strong {
  font-size: 28px;
}

.summary-strip span {
  color: var(--muted);
  font-size: 13px;
  margin-top: 4px;
}

.admin-filters {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  display: grid;
  gap: 12px;
  grid-template-columns: 1.6fr repeat(7, minmax(120px, 1fr));
  margin-bottom: 18px;
  padding: 16px;
}

.admin-filters button {
  align-self: end;
}

.admin-grid {
  align-items: start;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(360px, 0.95fr) minmax(420px, 1.05fr);
}

.admin-list-panel,
.lead-detail {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
}

.admin-table-section {
  display: block;
}

.admin-shell label {
  font-weight: 700;
}

.admin-shell h1,
.admin-shell h2,
.admin-shell h3,
.list-head strong,
.lead-cell strong {
  font-weight: 800;
}

.list-head {
  align-items: center;
  border-bottom: 1px solid var(--line);
  display: flex;
  justify-content: space-between;
  padding: 16px;
}

.list-head span {
  color: var(--muted);
}

.lead-table {
  overflow-x: auto;
}

.lead-table__head,
.lead-table__row {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(170px, 1.2fr) minmax(220px, 1.35fr) minmax(100px, 0.6fr) minmax(96px, 0.55fr) minmax(130px, 0.8fr) 92px;
  min-width: 920px;
}

.lead-table__head {
  background: var(--soft);
  border-bottom: 1px solid var(--line);
  color: var(--muted);
  font-size: 12px;
  font-weight: 800;
  padding: 12px 16px;
  text-transform: uppercase;
}

.lead-entry {
  background: #ffffff;
  border-bottom: 1px solid var(--line);
}

.lead-entry--open {
  background: #fbfcff;
}

.lead-table__row {
  padding: 14px 16px;
}

.lead-cell {
  min-width: 0;
}

.lead-cell strong,
.lead-cell span {
  display: block;
}

.lead-cell--lead span,
.lead-cell--muted {
  color: var(--muted);
  font-size: 13px;
  margin-top: 4px;
}

.lead-cell--contact {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.lead-cell--contact a,
.lead-cell--contact span {
  align-items: center;
  color: var(--navy);
  display: inline-flex;
  font-size: 13px;
  font-weight: 600;
  gap: 6px;
  overflow-wrap: anywhere;
  text-decoration: none;
}

.lead-cell--contact a:hover {
  color: var(--red);
}

.lead-cell--contact .icon {
  color: currentColor;
  height: 14px;
  width: 14px;
}

.lead-cell--action {
  justify-self: end;
}

.lead-cell--action button {
  min-height: 36px;
  padding: 8px 12px;
}

.lead-expanded {
  border-top: 1px solid var(--line);
  display: grid;
  gap: 18px;
  padding: 18px;
}

.lead-update-panel {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 16px;
}

.lead-update-panel h3 {
  font-size: 18px;
  margin-bottom: 14px;
}

.lead-list {
  display: flex;
  flex-direction: column;
  max-height: 780px;
  overflow: auto;
}

.lead-row {
  background: #ffffff;
  border-bottom: 1px solid var(--line);
  border-radius: 0;
  color: var(--ink);
}

.lead-row:hover,
.lead-row--active {
  background: var(--soft);
}

.lead-row__main {
  background: transparent;
  border: 0;
  border-radius: 0;
  color: var(--ink);
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) auto auto;
  justify-items: start;
  min-height: 0;
  padding: 16px 16px 8px;
  text-align: left;
  width: 100%;
}

.lead-row__main:hover {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  color: var(--ink);
  transform: none;
}

.lead-row__identity {
  min-width: 0;
}

.lead-row__identity strong,
.lead-row__identity small {
  display: block;
}

.lead-row__identity small {
  color: var(--muted);
  overflow-wrap: anywhere;
  margin-top: 4px;
}

.lead-row__contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 16px 16px;
}

.lead-row__contacts a,
.lead-detail__contacts a {
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--navy);
  display: inline-flex;
  font-size: 13px;
  font-weight: 900;
  gap: 6px;
  min-height: 34px;
  overflow-wrap: anywhere;
  padding: 7px 9px;
  text-decoration: none;
}

.lead-row__contacts a:hover,
.lead-detail__contacts a:hover {
  background: #fff5f7;
  border-color: rgba(235, 40, 63, 0.28);
  color: var(--red);
}

.lead-row__contacts .icon,
.lead-detail__contacts .icon {
  color: currentColor;
  height: 14px;
  width: 14px;
}

.pill,
.priority {
  border-radius: 8px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 900;
  justify-content: center;
  padding: 7px 10px;
  text-transform: uppercase;
  white-space: nowrap;
}

.pill--new,
.pill--contacted,
.priority--cold {
  background: #e7ecf6;
  color: var(--navy);
}

.pill--follow-up,
.priority--warm {
  background: var(--yellow);
  color: #6f5700;
}

.pill--qualified,
.pill--converted {
  background: #e8f6ef;
  color: #1f6a48;
}

.pill--not-interested,
.priority--hot {
  background: #fff0f2;
  color: var(--red-dark);
}

.pill--closed {
  background: #eceff4;
  color: #4b5563;
}

.lead-detail {
  padding: 22px;
  position: sticky;
  top: 86px;
}

.lead-detail__head {
  border-bottom: 1px solid var(--line);
  margin-bottom: 18px;
  padding-bottom: 18px;
}

.lead-detail__head h2 {
  margin: 12px 0 6px;
}

.lead-detail__contacts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.lead-meta {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0 0 18px;
}

.lead-meta div,
.query-box {
  background: var(--soft);
  border-radius: 8px;
  padding: 14px;
}

.lead-meta dt {
  color: var(--muted);
  font-size: 12px;
  font-weight: 900;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.lead-meta dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.query-box {
  margin-bottom: 18px;
}

.query-box p {
  margin: 8px 0 0;
}

.admin-update {
  border-bottom: 1px solid var(--line);
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 18px;
  padding-bottom: 18px;
}

.admin-update label:nth-last-of-type(1),
.admin-update button {
  grid-column: 1 / -1;
}

.timeline h3 {
  margin-bottom: 12px;
}

.timeline-item {
  border-left: 3px solid var(--red);
  padding: 0 0 18px 14px;
}

.timeline-item strong,
.timeline-item span {
  display: block;
}

.timeline-item span {
  color: var(--muted);
  font-size: 13px;
  margin-top: 4px;
}

.timeline-item p {
  margin: 8px 0 0;
}

.empty-state {
  color: var(--muted);
  padding: 24px;
}

@media (max-width: 1180px) {
  .header-main {
    align-items: center;
    grid-template-columns: 1fr auto;
    padding-bottom: 14px;
  }

  .menu-toggle {
    align-items: center;
    background: var(--navy);
    border-color: var(--navy);
    display: flex;
    flex-direction: column;
    gap: 5px;
    height: 42px;
    min-height: 40px;
    padding: 0;
    width: 46px;
  }

  .menu-toggle span {
    background: #ffffff;
    border-radius: 999px;
    display: block;
    height: 2px;
    transition: transform 0.18s ease, opacity 0.18s ease;
    width: 20px;
  }

  .site-header--open .menu-toggle span:first-child {
    transform: translateY(7px) rotate(45deg);
  }

  .site-header--open .menu-toggle span:nth-child(2) {
    opacity: 0;
  }

  .site-header--open .menu-toggle span:last-child {
    transform: translateY(-7px) rotate(-45deg);
  }

  .nav-links,
  .header-actions {
    display: none;
    grid-column: 1 / -1;
    grid-row: auto;
  }

  .nav-links {
    border-radius: 8px;
    margin-left: 0;
    margin-right: 0;
    padding: 10px;
  }

  .header-actions {
    justify-content: stretch;
  }

  .site-header--open .nav-links,
  .site-header--open .header-actions {
    align-items: stretch;
    animation: menuDrop 0.18s ease both;
    display: flex;
    flex-direction: column;
  }

  .site-header--open .nav-links button,
  .site-header--open .header-actions button,
  .site-header--open .header-actions .button {
    justify-content: center;
    width: 100%;
  }

  .site-header--open .language-switch {
    width: 100%;
  }

  .site-header--open .language-switch__option {
    flex: 1 1;
    width: auto;
  }

  .site-header--open .header-actions {
    background: #ffffff;
    border: 1px solid var(--line);
    border-radius: 8px;
    padding: 10px;
  }

  .hero,
  .split-section,
  .documents-card,
  .contact-grid,
  .admin-grid {
    grid-template-columns: 1fr;
  }

  .lead-detail {
    position: static;
  }

  .admin-filters {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .footer-main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .photo-stack-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 860px) {
  h1 {
    font-size: 40px;
  }

  h2 {
    font-size: 30px;
  }

  .hero {
    padding-top: 34px;
  }

  .documents-card {
    padding: 18px;
  }

  .document-visual {
    min-height: 330px;
    padding: 18px;
  }

  .document-visual svg {
    max-width: 280px;
  }

  .form-grid,
  .info-grid,
  .info-grid--four,
  .document-list,
  .college-grid,
  .college-card,
  .review-grid,
  .faq-grid,
  .step-grid,
  .service-grid,
  .summary-strip,
  .admin-filters,
  .lead-meta,
  .admin-update {
    grid-template-columns: 1fr;
  }

  .college-card .college-card__content,
  .college-card:nth-child(even) .college-card__content {
    order: 2;
  }

  .college-card__photo,
  .college-card:nth-child(even) .college-card__photo {
    order: 1;
  }

  .trust-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .photo-stack-grid,
  .photo-gallery {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .review-grid {
    grid-auto-columns: minmax(280px, 82vw);
    grid-template-columns: none;
  }

  .service-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .service-grid div {
    min-height: 118px;
    padding: 14px;
  }

  .service-grid span {
    font-size: 13px;
    line-height: 1.35;
  }

  .service-grid .icon {
    height: 36px;
    width: 36px;
  }

  .lead-table {
    overflow-x: visible;
  }

  .lead-table__head {
    display: none;
  }

  .lead-table__row {
    align-items: stretch;
    gap: 12px;
    grid-template-columns: 1fr;
    min-width: 0;
    padding: 14px;
  }

  .lead-cell--contact {
    background: var(--soft);
    border-radius: 8px;
    padding: 10px;
  }

  .lead-cell--action {
    justify-self: stretch;
  }

  .lead-cell--action button {
    width: 100%;
  }

  .lead-expanded {
    padding: 14px;
  }

  .cta-strip,
  .footer-bottom,
  .admin-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .footer-main {
    gap: 22px 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-brand,
  .footer-contact {
    grid-column: 1 / -1;
  }

  .footer-column h3 {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .footer-column a {
    font-size: 13px;
    line-height: 1.35;
  }

  .footer-column ul {
    gap: 8px;
  }

  .footer-bottom {
    align-items: flex-start;
  }

  .footer-map {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .site-header,
  .hero,
  .section-band,
  .services-section,
  .contact-section,
  .site-footer,
  .admin-shell {
    padding-left: 14px;
    padding-right: 14px;
  }

  .header-actions,
  .header-actions .button,
  .header-actions button,
  .language-switch,
  .hero-actions,
  .hero-actions .button,
  .hero-actions button,
  .admin-header__actions,
  .admin-header__actions button {
    width: 100%;
  }

  .brand-lockup strong {
    font-size: 19px;
  }

  .brand-lockup span {
    font-size: 13px;
  }

  h1 {
    font-size: 34px;
  }

  .lead-form,
  .modal,
  .photo-modal,
  .trust-box,
  .login-card,
  .lead-detail {
    padding: 18px;
  }

  .photo-stack-grid {
    gap: 12px;
  }

  .photo-stack-card {
    min-height: 268px;
    padding: 10px;
  }

  .stack-images {
    height: 138px;
  }

  .stack-images img {
    height: 112px;
  }

  .stack-icon {
    height: 34px;
    left: 16px;
    top: 16px;
    width: 34px;
  }

  .stack-icon .icon {
    height: 17px;
    width: 17px;
  }

  .photo-stack-card strong {
    font-size: 15px;
  }

  .photo-stack-card small {
    font-size: 12px;
  }

  .photo-gallery {
    grid-template-columns: 1fr;
  }

  .floating-enquiry {
    bottom: 14px;
    right: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,uGAAuG;AACzG;;AAEA;;;;EAIE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,+HAA+H;AACjI;;AAEA;;EAEE,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;;;EAGE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,iCAAiC;EACnC;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,qBAAqB;IACrB,sBAAsB;EACxB;EACA;;IAEE,UAAU;IACV,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;;IAEE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,mDAAmD;EACnD,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mDAAmD;EACnD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,yDAAyD;EACzD,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;;;EAKE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;;EAIE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE;;WAES;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;EAKE,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8DAA8D;EAC9D,gBAAgB;EAChB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,8DAA8D;EAC9D,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,mDAAmD;EACnD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yDAAyD;EACzD,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,MAAM;EACN,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE;;0DAEoD;EACpD,cAAc;EACd,eAAe;EACf,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sFAAsF;EACtF,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,kEAAkE;EAClE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,0DAA0D;EAC1D,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,kEAAkE;AACpE;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,qIAAqI;EACrI,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,oDAAoD;IACpD,WAAW;EACb;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,oBAAoB;IACpB,mCAAmC;IACnC,aAAa;IACb,sBAAsB;EACxB;;EAEA;;;IAGE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;EACf;;EAEA;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;IAcE,0BAA0B;EAC5B;;EAEA;;IAEE,QAAQ;EACV;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,SAAS;IACT,0BAA0B;IAC1B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,gDAAgD;EAClD;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;;;;IAOE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;;;;;;IASE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,gCAAgC;IAChC,sCAAsC;EACxC;AACF","sourcesContent":[":root {\n  --bg: #ffffff;\n  --soft: #f3f6fd;\n  --soft-2: #eef3fb;\n  --surface: #ffffff;\n  --ink: #08101f;\n  --muted: #5e687a;\n  --line: #c8d3ea;\n  --navy: #112d63;\n  --navy-dark: #061126;\n  --red: #eb283f;\n  --red-dark: #c81f34;\n  --red-hover: #f04456;\n  --red-deep: #8f1323;\n  --yellow: #ffe8a3;\n  --shadow: 0 18px 46px rgba(17, 45, 99, 0.12);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  background: var(--bg);\n  color: var(--ink);\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n  letter-spacing: 0;\n}\n\nbutton,\n.button {\n  align-items: center;\n  background: var(--red);\n  border: 1px solid var(--red);\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 900;\n  justify-content: center;\n  min-height: 46px;\n  padding: 12px 18px;\n  text-decoration: none;\n  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n}\n\nbutton:hover:not(:disabled),\n.button:hover {\n  background: var(--red-hover);\n  border-color: var(--red-hover);\n  transform: translateY(-1px);\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.button-light {\n  background: #ffffff;\n  border-color: var(--line);\n  color: var(--navy);\n}\n\n.button-light:hover {\n  background: var(--soft);\n  border-color: var(--line);\n  color: var(--navy);\n}\n\nlabel {\n  color: var(--ink);\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 800;\n  gap: 8px;\n}\n\ninput,\nselect,\ntextarea {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--ink);\n  font-weight: 400;\n  outline: none;\n  padding: 12px 13px;\n  width: 100%;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: #8a94a6;\n  font-weight: 400;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n  border-color: var(--red);\n  box-shadow: 0 0 0 4px rgba(235, 40, 63, 0.14);\n}\n\ntextarea {\n  resize: vertical;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n}\n\n.icon {\n  color: currentColor;\n  flex: 0 0 auto;\n  fill: none;\n  height: 18px;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.9;\n  width: 18px;\n}\n\nbutton .icon,\n.button .icon,\n.nav-links .icon {\n  height: 16px;\n  margin-right: 8px;\n  width: 16px;\n}\n\n.card-icon {\n  background: rgba(235, 40, 63, 0.09);\n  border: 1px solid rgba(235, 40, 63, 0.18);\n  border-radius: 8px;\n  color: var(--red);\n  height: 42px;\n  margin-bottom: 18px;\n  padding: 9px;\n  width: 42px;\n}\n\nh1,\nh2,\nh3,\np {\n  margin-top: 0;\n}\n\nh1 {\n  font-size: 58px;\n  line-height: 1.04;\n  margin-bottom: 18px;\n  max-width: 860px;\n}\n\nh2 {\n  font-size: 38px;\n  line-height: 1.12;\n  margin-bottom: 12px;\n}\n\nh3 {\n  font-size: 21px;\n  line-height: 1.24;\n  margin-bottom: 8px;\n}\n\np {\n  color: var(--muted);\n  font-size: 16px;\n  line-height: 1.65;\n}\n\n.site-shell {\n  min-height: 100vh;\n}\n\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(18px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes menuDrop {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes serviceIconFloat {\n  0%,\n  100% {\n    transform: translateY(0) scale(1);\n  }\n  50% {\n    transform: translateY(-4px) scale(1.06);\n  }\n}\n\n@keyframes documentFloat {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-8px);\n  }\n}\n\n@keyframes tickDraw {\n  0%,\n  14% {\n    opacity: 0;\n    stroke-dashoffset: 34;\n    transform: scale(0.86);\n  }\n  24%,\n  78% {\n    opacity: 1;\n    stroke-dashoffset: 0;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    stroke-dashoffset: 0;\n    transform: scale(1);\n  }\n}\n\n@keyframes clipboardMotion {\n  0%,\n  100% {\n    transform: translateY(0) rotate(-1deg);\n  }\n  50% {\n    transform: translateY(-5px) rotate(1deg);\n  }\n}\n\n@keyframes heldPaperMotion {\n  0%,\n  100% {\n    transform: translateY(0) rotate(-1deg);\n  }\n  50% {\n    transform: translateY(-4px) rotate(2deg);\n  }\n}\n\n.site-header {\n  padding-top: 87px;\n  position: relative;\n  z-index: 30;\n}\n\n.header-main {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.94);\n  border-bottom: 1px solid var(--line);\n  display: grid;\n  gap: 18px;\n  grid-template-columns: auto 1fr auto;\n  padding: 16px max(22px, calc((100vw - 1180px) / 2));\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 32;\n}\n\n.brand-lockup {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  grid-column: 1;\n}\n\n.brand-lockup img {\n  height: 54px;\n  width: 54px;\n}\n\n.brand-lockup strong,\n.brand-lockup span {\n  display: block;\n}\n\n.brand-lockup strong {\n  font-size: 22px;\n  line-height: 1.1;\n}\n\n.brand-lockup span {\n  color: var(--muted);\n  font-weight: 700;\n}\n\n.nav-links,\n.header-actions,\n.hero-actions,\n.admin-header__actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.header-actions {\n  grid-column: 3;\n  justify-content: flex-end;\n}\n\n.language-switch {\n  align-items: center;\n  background: var(--soft);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  display: inline-flex;\n  gap: 4px;\n  margin-bottom: 12px;\n  padding: 4px;\n}\n\n.language-switch__option {\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--navy);\n  font-size: 12px;\n  font-weight: 900;\n  min-height: 34px;\n  padding: 7px 10px;\n}\n\n.language-switch__option:hover {\n  background: #ffffff;\n  border-color: transparent;\n  color: var(--navy);\n  transform: none;\n}\n\n.language-switch__option--active,\n.language-switch__option--active:hover {\n  background: var(--red);\n  color: #ffffff;\n}\n\n.menu-toggle {\n  display: none;\n}\n\n.nav-links {\n  background: var(--red);\n  justify-content: center;\n  padding: 10px max(22px, calc((100vw - 1180px) / 2));\n  position: relative;\n  z-index: 20;\n}\n\n.nav-links button {\n  background: transparent;\n  border-color: transparent;\n  color: #ffffff;\n  min-height: 38px;\n  padding: 8px 10px;\n}\n\n.nav-links button:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.hero {\n  background: linear-gradient(180deg, var(--soft), #ffffff);\n  display: grid;\n  gap: 40px;\n  grid-template-columns: minmax(0, 1fr) minmax(380px, 0.82fr);\n  margin: 0 auto;\n  max-width: 1180px;\n  padding: 64px 20px 54px;\n}\n\n.badge,\n.eyebrow {\n  color: var(--red);\n  display: inline-flex;\n  font-size: 13px;\n  font-weight: 900;\n  letter-spacing: 0;\n  margin-bottom: 14px;\n  text-transform: uppercase;\n}\n\n.badge {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--navy);\n  padding: 9px 12px;\n  text-transform: none;\n}\n\n.hero-copy > p {\n  font-size: 18px;\n  max-width: 760px;\n}\n\n.hero-copy,\n.hero-media,\n.section-heading,\n.info-card,\n.college-card,\n.step-card,\n.review-card,\n.faq-card,\n.contact-grid,\n.cta-strip {\n  animation: fadeUp 0.55s ease both;\n}\n\n.hero-points {\n  display: grid;\n  gap: 14px;\n  margin: 24px 0;\n  max-width: 760px;\n}\n\n.point {\n  align-items: flex-start;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 50px 1fr;\n}\n\n.point > span {\n  align-items: center;\n  background: rgba(235, 40, 63, 0.1);\n  border-radius: 8px;\n  color: var(--red);\n  display: flex;\n  height: 42px;\n  justify-content: center;\n  width: 42px;\n}\n\n.point > span .icon {\n  height: 20px;\n  width: 20px;\n}\n\n.point strong {\n  display: block;\n  font-size: 19px;\n  margin-bottom: 2px;\n}\n\n.point p {\n  margin-bottom: 0;\n}\n\n.trust-row {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-top: 22px;\n  max-width: 720px;\n}\n\n.trust-row div {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  padding: 16px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.trust-row div:hover {\n  border-color: rgba(235, 40, 63, 0.34);\n  box-shadow: var(--shadow);\n  transform: translateY(-3px);\n}\n\n.trust-row .icon {\n  color: var(--red);\n  height: 22px;\n  margin-bottom: 10px;\n  width: 22px;\n}\n\n.trust-row strong,\n.trust-row span {\n  display: block;\n}\n\n.trust-row strong {\n  font-size: 24px;\n}\n\n.trust-row span {\n  color: var(--muted);\n  margin-top: 4px;\n}\n\n.hero-media {\n  align-self: start;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  box-shadow: var(--shadow);\n  overflow: hidden;\n}\n\n.hero-media > img {\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  width: 100%;\n}\n\n.hero-form-panel {\n  padding: 22px;\n}\n\n.lead-form {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 26px;\n}\n\n.lead-form--compact {\n  border: 0;\n  box-shadow: none;\n  padding: 0;\n}\n\n.form-heading span {\n  color: var(--red);\n  display: block;\n  font-size: 12px;\n  font-weight: 900;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n}\n\n.form-heading h2 {\n  font-size: 26px;\n  margin-bottom: 4px;\n}\n\n.form-heading p,\n.privacy-text {\n  font-size: 13px;\n  margin-bottom: 0;\n}\n\n.form-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.form-status {\n  background: var(--soft);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--navy);\n  margin: 0;\n  padding: 10px 12px;\n}\n\n.form-status--error {\n  background: #fff5f7;\n  border-color: #ffc2c9;\n  color: var(--red-dark);\n}\n\n.section-band,\n.services-section,\n.review-cta-section,\n.contact-section,\n.site-footer {\n  margin: 0 auto;\n  max-width: 1180px;\n  padding: 70px 20px;\n}\n\n.review-cta-section {\n  padding-top: 0;\n}\n\n.section-muted {\n  background: var(--soft);\n  max-width: none;\n  padding-left: max(20px, calc((100vw - 1180px) / 2));\n  padding-right: max(20px, calc((100vw - 1180px) / 2));\n}\n\n.section-heading {\n  max-width: 780px;\n}\n\n.section-heading--center {\n  margin: 0 auto 26px;\n  text-align: center;\n}\n\n.info-grid,\n.college-grid,\n.review-grid,\n.faq-grid {\n  display: grid;\n  gap: 18px;\n  margin-top: 26px;\n}\n\n.info-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.info-grid--four {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.college-grid {\n  grid-template-columns: 1fr;\n}\n\n.review-grid {\n  grid-auto-columns: minmax(320px, 390px);\n  grid-auto-flow: column;\n  grid-template-columns: none;\n  overflow-x: auto;\n  padding-bottom: 14px;\n  scroll-snap-type: x mandatory;\n  scrollbar-color: var(--red) var(--soft);\n}\n\n.review-grid::-webkit-scrollbar {\n  height: 8px;\n}\n\n.review-grid::-webkit-scrollbar-track {\n  background: var(--soft);\n  border-radius: 999px;\n}\n\n.review-grid::-webkit-scrollbar-thumb {\n  background: var(--red);\n  border-radius: 999px;\n}\n\n.faq-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.info-card,\n.review-card,\n.faq-card,\n.step-card {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  padding: 22px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.review-card {\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(243, 246, 253, 0.88)),\n    #ffffff;\n  min-height: 340px;\n  overflow: hidden;\n  padding: 24px;\n  position: relative;\n  scroll-snap-align: start;\n}\n\n.review-card::before {\n  color: rgba(235, 40, 63, 0.1);\n  content: \"\\\"\";\n  font-size: 120px;\n  font-weight: 900;\n  line-height: 1;\n  position: absolute;\n  right: 18px;\n  top: 2px;\n}\n\n.review-card__top {\n  align-items: center;\n  border-bottom: 1px solid rgba(200, 211, 234, 0.7);\n  display: flex;\n  gap: 14px;\n  margin-bottom: 18px;\n  padding-bottom: 18px;\n  position: relative;\n  z-index: 1;\n}\n\n.info-card:hover,\n.college-card:hover,\n.review-card:hover,\n.faq-card:hover,\n.step-card:hover {\n  border-color: rgba(235, 40, 63, 0.28);\n  box-shadow: var(--shadow);\n  transform: translateY(-4px);\n}\n\n.college-card {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  display: grid;\n  gap: 28px;\n  grid-template-columns: minmax(0, 0.92fr) minmax(360px, 1.08fr);\n  overflow: hidden;\n  padding: 28px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.college-card:hover {\n  border-color: rgba(235, 40, 63, 0.28);\n  box-shadow: var(--shadow);\n  transform: translateY(-4px);\n}\n\n.college-card:nth-child(even) .college-card__content {\n  order: 2;\n}\n\n.college-card:nth-child(even) .college-card__photo {\n  order: 1;\n}\n\n.college-card__photo {\n  aspect-ratio: 16 / 9;\n  border-radius: 8px;\n  height: 100%;\n  max-height: 360px;\n  object-fit: cover;\n  width: 100%;\n}\n\n.college-card__title {\n  align-items: center;\n  display: grid;\n  gap: 14px;\n  grid-template-columns: 70px 1fr;\n  margin-bottom: 8px;\n}\n\n.college-card__title img {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  height: 70px;\n  object-fit: contain;\n  padding: 8px;\n  width: 70px;\n}\n\n.college-card h3 {\n  color: var(--navy);\n  font-size: 32px;\n  margin-bottom: 0;\n}\n\n.college-fee {\n  color: var(--red);\n  display: block;\n  font-size: 20px;\n  margin-bottom: 12px;\n}\n\n.info-card p,\n.college-card p,\n.review-card p,\n.faq-card p,\n.step-card p {\n  margin-bottom: 0;\n}\n\n.note {\n  border-left: 4px solid var(--red);\n  margin: 20px 0 0;\n  padding-left: 14px;\n}\n\n.step-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-top: 24px;\n}\n\n.step-card {\n  align-items: flex-start;\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 54px 1fr;\n}\n\n.step-card > span {\n  align-items: center;\n  background: rgba(235, 40, 63, 0.1);\n  border-radius: 8px;\n  color: var(--red);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  height: 48px;\n  justify-content: center;\n}\n\n.step-card > span .icon {\n  height: 18px;\n  width: 18px;\n}\n\n.step-card > span small {\n  font-size: 11px;\n  font-weight: 900;\n}\n\n.documents-section {\n  padding-top: 36px;\n}\n\n.documents-card {\n  align-items: center;\n  background: linear-gradient(135deg, #ffffff, var(--soft));\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  box-shadow: var(--shadow);\n  display: grid;\n  gap: 34px;\n  grid-template-columns: minmax(280px, 0.78fr) minmax(0, 1.22fr);\n  overflow: hidden;\n  padding: 28px;\n}\n\n.document-visual {\n  align-items: center;\n  background: linear-gradient(145deg, var(--navy), #183b7a);\n  border-radius: 8px;\n  color: #ffffff;\n  display: flex;\n  justify-content: center;\n  min-height: 470px;\n  overflow: hidden;\n  padding: 28px;\n  position: relative;\n}\n\n.document-visual::before,\n.document-visual::after {\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  content: \"\";\n  height: 180px;\n  position: absolute;\n  width: 180px;\n}\n\n.document-visual::before {\n  left: -64px;\n  top: -54px;\n}\n\n.document-visual::after {\n  bottom: -70px;\n  right: -58px;\n}\n\n.document-pad {\n  animation: documentFloat 4.2s ease-in-out infinite;\n  max-width: 390px;\n  overflow: visible;\n  position: relative;\n  width: 100%;\n  z-index: 2;\n}\n\n.document-pad__halo {\n  fill: rgba(255, 255, 255, 0.08);\n}\n\n.document-pad__halo--two,\n.document-pad__halo--three {\n  fill: rgba(255, 255, 255, 0.12);\n}\n\n.document-pad__shadow {\n  fill: rgba(0, 0, 0, 0.18);\n}\n\n.document-pad__stack {\n  opacity: 0.92;\n  transform: rotate(-4deg);\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-pad__sheet {\n  fill: rgba(255, 255, 255, 0.62);\n  stroke: rgba(255, 255, 255, 0.36);\n  stroke-width: 3;\n}\n\n.document-pad__sheet--mid {\n  fill: rgba(255, 255, 255, 0.76);\n}\n\n.document-pad__fold {\n  fill: rgba(17, 45, 99, 0.08);\n  stroke: rgba(17, 45, 99, 0.14);\n  stroke-width: 3;\n}\n\n.document-pad__clipboard {\n  animation: clipboardMotion 4.8s ease-in-out infinite;\n  filter: drop-shadow(0 26px 34px rgba(0, 0, 0, 0.2));\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-pad__board {\n  fill: url(\"#padGradient\");\n  stroke: rgba(255, 255, 255, 0.18);\n  stroke-width: 4;\n}\n\n.document-pad__paper {\n  fill: url(\"#paperGradient\");\n  stroke: rgba(17, 45, 99, 0.18);\n  stroke-width: 3;\n}\n\n.document-pad__clip {\n  fill: #d7e0f2;\n  stroke: rgba(17, 45, 99, 0.2);\n  stroke-width: 3;\n}\n\n.document-pad__clip-dot {\n  fill: #a8b7d5;\n}\n\n.document-pad__box {\n  fill: #ffffff;\n  stroke: rgba(17, 45, 99, 0.2);\n  stroke-width: 2;\n}\n\n.document-pad__line {\n  fill: none;\n  stroke: #9aa9c9;\n  stroke-linecap: round;\n  stroke-width: 7;\n}\n\n.document-pad__line--short {\n  opacity: 0.62;\n  stroke-width: 5;\n}\n\n.document-pad__tick,\n.document-pad__seal-check {\n  fill: none;\n  opacity: 0;\n  stroke: var(--red);\n  stroke-dasharray: 34;\n  stroke-dashoffset: 34;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 6;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-pad__tick {\n  animation: tickDraw 4.8s ease-in-out infinite;\n}\n\n.document-pad__tick--2 {\n  animation-delay: 0.45s;\n}\n\n.document-pad__tick--3 {\n  animation-delay: 0.9s;\n}\n\n.document-pad__tick--4 {\n  animation-delay: 1.35s;\n}\n\n.document-pad__tick--5 {\n  animation-delay: 1.8s;\n}\n\n.document-pad__seal {\n  fill: rgba(235, 40, 63, 0.11);\n  stroke: var(--red);\n  stroke-width: 7;\n}\n\n.document-pad__seal-check {\n  animation: tickDraw 4.8s ease-in-out 2.25s infinite;\n  stroke-width: 8;\n}\n\n.document-character {\n  max-width: 390px;\n  overflow: visible;\n  position: relative;\n  width: 100%;\n  z-index: 2;\n}\n\n.document-character__shadow {\n  fill: rgba(0, 0, 0, 0.18);\n}\n\n.document-character__clipboard {\n  animation: clipboardMotion 4.4s ease-in-out infinite;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-character__board {\n  fill: #0b234f;\n  stroke: rgba(255, 255, 255, 0.18);\n  stroke-width: 4;\n}\n\n.document-character__paper,\n.document-character__held-sheet {\n  fill: url(\"#paperGradient\");\n  stroke: rgba(17, 45, 99, 0.18);\n  stroke-width: 3;\n}\n\n.document-character__clip {\n  fill: #d7e0f2;\n  stroke: rgba(17, 45, 99, 0.2);\n  stroke-width: 3;\n}\n\n.document-character__clip-dot {\n  fill: #a8b7d5;\n}\n\n.document-character__line,\n.document-character__held-line {\n  fill: none;\n  stroke: #9aa9c9;\n  stroke-linecap: round;\n  stroke-width: 6;\n}\n\n.document-character__box {\n  fill: #ffffff;\n  stroke: rgba(17, 45, 99, 0.2);\n  stroke-width: 2;\n}\n\n.document-character__tick,\n.document-character__held-tick {\n  fill: none;\n  opacity: 0;\n  stroke: var(--red);\n  stroke-dasharray: 34;\n  stroke-dashoffset: 34;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 6;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-character__tick {\n  animation: tickDraw 4.8s ease-in-out infinite;\n}\n\n.document-character__tick--2 {\n  animation-delay: 0.45s;\n}\n\n.document-character__tick--3 {\n  animation-delay: 0.9s;\n}\n\n.document-character__tick--4 {\n  animation-delay: 1.35s;\n}\n\n.document-character__tick--5 {\n  animation-delay: 1.8s;\n}\n\n.document-character__held-tick {\n  animation: tickDraw 4.8s ease-in-out 2.25s infinite;\n  stroke-width: 8;\n}\n\n.document-character__person {\n  animation: documentFloat 4.2s ease-in-out infinite;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-character__leg {\n  fill: #0d224b;\n}\n\n.document-character__leg--right {\n  fill: #132e63;\n}\n\n.document-character__shoe {\n  fill: #061126;\n}\n\n.document-character__torso {\n  fill: url(\"#shirtGradient\");\n}\n\n.document-character__neck,\n.document-character__face,\n.document-character__hand {\n  fill: #f2b08a;\n}\n\n.document-character__hair {\n  fill: #672f27;\n}\n\n.document-character__smile {\n  fill: none;\n  stroke: #ffffff;\n  stroke-linecap: round;\n  stroke-width: 4;\n}\n\n.document-character__eye {\n  fill: #33201d;\n}\n\n.document-character__arm,\n.document-character__arm--right {\n  fill: none;\n  stroke: #f2b08a;\n  stroke-linecap: round;\n  stroke-width: 18;\n}\n\n.document-character__arm--right {\n  stroke-width: 17;\n}\n\n.document-character__held-paper {\n  animation: heldPaperMotion 3.4s ease-in-out infinite;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n\n.document-character__held-fold {\n  fill: rgba(17, 45, 99, 0.08);\n  stroke: rgba(17, 45, 99, 0.14);\n  stroke-width: 3;\n}\n\n.document-dashboard {\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.34);\n  border-radius: 8px;\n  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);\n  color: var(--ink);\n  max-width: 380px;\n  padding: 18px;\n  position: relative;\n  width: 100%;\n  z-index: 2;\n}\n\n.document-dashboard__head {\n  align-items: center;\n  border-bottom: 1px solid var(--line);\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding-bottom: 14px;\n}\n\n.document-dashboard__head span,\n.document-progress span,\n.document-upload-card span {\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.document-dashboard__head strong {\n  background: rgba(235, 40, 63, 0.09);\n  border-radius: 8px;\n  color: var(--red);\n  font-size: 12px;\n  padding: 7px 9px;\n}\n\n.document-upload-card {\n  align-items: flex-start;\n  background: linear-gradient(135deg, var(--soft), #ffffff);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 46px 1fr;\n  margin-bottom: 14px;\n  padding: 14px;\n}\n\n.document-upload-card__icon {\n  align-items: center;\n  background: var(--navy);\n  border-radius: 8px;\n  color: #ffffff;\n  display: flex;\n  height: 44px;\n  justify-content: center;\n  width: 44px;\n}\n\n.document-upload-card__icon .icon {\n  height: 24px;\n  width: 24px;\n}\n\n.document-upload-card strong,\n.document-upload-card span {\n  display: block;\n}\n\n.document-upload-card strong {\n  color: var(--navy);\n  font-size: 16px;\n  line-height: 1.25;\n  margin-bottom: 6px;\n}\n\n.document-upload-card span {\n  line-height: 1.45;\n}\n\n.document-progress {\n  background: var(--navy-dark);\n  border-radius: 8px;\n  color: #ffffff;\n  margin-bottom: 14px;\n  padding: 14px;\n}\n\n.document-progress span,\n.document-progress strong {\n  display: block;\n}\n\n.document-progress span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.document-progress strong {\n  color: #ffffff;\n  font-size: 15px;\n  margin-top: 4px;\n}\n\n.document-progress div {\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 999px;\n  height: 7px;\n  margin-top: 12px;\n  overflow: hidden;\n}\n\n.document-progress div span {\n  background: var(--red);\n  border-radius: inherit;\n  display: block;\n  height: 100%;\n  width: 78%;\n}\n\n.document-mini-grid {\n  display: grid;\n  gap: 9px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.document-mini-grid span {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--navy);\n  font-size: 12px;\n  font-weight: 900;\n  line-height: 1.35;\n  min-height: 46px;\n  padding: 10px;\n}\n\n.document-floating-card {\n  align-items: center;\n  backdrop-filter: blur(12px);\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 8px;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.18);\n  color: #ffffff;\n  display: inline-flex;\n  font-size: 13px;\n  font-weight: 900;\n  gap: 8px;\n  padding: 11px 13px;\n  position: absolute;\n  z-index: 3;\n}\n\n.document-floating-card .icon {\n  color: #ffffff;\n  height: 17px;\n  width: 17px;\n}\n\n.document-floating-card--top {\n  right: 22px;\n  top: 26px;\n}\n\n.document-floating-card--bottom {\n  bottom: 26px;\n  left: 22px;\n}\n\n.document-art {\n  max-width: 360px;\n  position: relative;\n  width: 100%;\n  z-index: 1;\n}\n\n.document-art__halo {\n  fill: rgba(255, 255, 255, 0.08);\n}\n\n.document-art__folder-back {\n  fill: rgba(255, 255, 255, 0.2);\n  stroke: rgba(255, 255, 255, 0.22);\n  stroke-width: 3;\n}\n\n.document-art__paper {\n  fill: #ffffff;\n  stroke: rgba(17, 45, 99, 0.18);\n  stroke-width: 3;\n}\n\n.document-art__paper--one {\n  opacity: 0.74;\n}\n\n.document-art__paper--two {\n  fill: url(\"#folderGradient\");\n}\n\n.document-art__fold {\n  fill: rgba(17, 45, 99, 0.08);\n  stroke: rgba(17, 45, 99, 0.16);\n  stroke-width: 3;\n}\n\n.document-art__folder-front {\n  fill: url(\"#folderGradient\");\n  stroke: rgba(255, 255, 255, 0.55);\n  stroke-width: 3;\n}\n\n.document-art__id-card {\n  fill: #ffffff;\n  stroke: rgba(17, 45, 99, 0.18);\n  stroke-width: 3;\n}\n\n.document-art__id-dot {\n  fill: rgba(235, 40, 63, 0.16);\n}\n\n.document-art__id-line,\n.document-art__clip {\n  fill: none;\n  stroke: #9aa9c9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 8;\n}\n\n.document-art__stamp {\n  fill: rgba(235, 40, 63, 0.12);\n  stroke: url(\"#accentGradient\");\n  stroke-width: 8;\n}\n\n.document-art__check {\n  fill: none;\n  stroke: var(--red);\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 10;\n}\n\n.document-orbit {\n  align-items: center;\n  backdrop-filter: blur(12px);\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 8px;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.16);\n  color: #ffffff;\n  display: flex;\n  height: 58px;\n  justify-content: center;\n  position: absolute;\n  width: 58px;\n  z-index: 3;\n}\n\n.document-orbit .icon {\n  height: 28px;\n  width: 28px;\n}\n\n.document-orbit--top {\n  right: 28px;\n  top: 30px;\n}\n\n.document-orbit--bottom {\n  bottom: 30px;\n  left: 28px;\n}\n\n.document-blob {\n  fill: rgba(255, 255, 255, 0.08);\n}\n\n.document-sheet {\n  fill: url(\"#documentGradient\");\n  stroke: rgba(17, 45, 99, 0.24);\n  stroke-width: 3;\n}\n\n.document-sheet--back {\n  fill: rgba(255, 255, 255, 0.34);\n}\n\n.document-fold {\n  fill: #f3f6fd;\n  stroke: rgba(17, 45, 99, 0.22);\n  stroke-width: 3;\n}\n\n.document-line {\n  fill: none;\n  stroke: #9aa9c9;\n  stroke-linecap: round;\n  stroke-width: 10;\n}\n\n.document-line--title {\n  stroke: var(--red);\n}\n\n.document-stamp {\n  fill: rgba(235, 40, 63, 0.11);\n  stroke: var(--red);\n  stroke-width: 8;\n}\n\n.document-check {\n  fill: none;\n  stroke: var(--red);\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 10;\n}\n\n.document-visual__chip {\n  align-items: center;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  bottom: 24px;\n  display: inline-flex;\n  font-weight: 900;\n  gap: 8px;\n  left: 24px;\n  padding: 10px 12px;\n  position: absolute;\n  z-index: 2;\n}\n\n.documents-copy > p {\n  max-width: 700px;\n}\n\n.document-list {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-top: 22px;\n}\n\n.document-list article {\n  align-items: flex-start;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 42px 1fr;\n  padding: 16px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.document-list article:hover {\n  border-color: rgba(235, 40, 63, 0.3);\n  box-shadow: 0 14px 34px rgba(17, 45, 99, 0.1);\n  transform: translateY(-3px);\n}\n\n.document-list article > span {\n  align-items: center;\n  background: rgba(235, 40, 63, 0.09);\n  border-radius: 8px;\n  color: var(--red);\n  display: flex;\n  font-size: 13px;\n  font-weight: 900;\n  height: 38px;\n  justify-content: center;\n  width: 38px;\n}\n\n.document-list h3 {\n  color: var(--navy);\n  font-size: 16px;\n  margin-bottom: 4px;\n}\n\n.document-list p {\n  font-size: 13px;\n  line-height: 1.5;\n  margin-bottom: 0;\n}\n\n.college-card__meta {\n  align-items: center;\n  color: var(--red);\n  display: flex;\n  font-size: 12px;\n  font-weight: 900;\n  gap: 8px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.college-card__meta .icon {\n  height: 17px;\n  width: 17px;\n}\n\n.college-card ul,\n.trust-box ul {\n  color: var(--muted);\n  line-height: 1.7;\n  margin: 14px 0 18px;\n  padding-left: 0;\n}\n\n.college-card li,\n.trust-box li {\n  align-items: flex-start;\n  display: flex;\n  gap: 8px;\n  list-style: none;\n  margin-top: 8px;\n}\n\n.college-card li .icon,\n.trust-box li .icon {\n  color: var(--red);\n  height: 16px;\n  margin-top: 5px;\n  width: 16px;\n}\n\n.college-card li .icon {\n  background: rgba(235, 40, 63, 0.08);\n  border-radius: 6px;\n  height: 22px;\n  margin-top: 2px;\n  padding: 4px;\n  width: 22px;\n}\n\n.college-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.split-section {\n  align-items: center;\n  display: grid;\n  gap: 34px;\n  grid-template-columns: minmax(0, 0.9fr) minmax(360px, 0.7fr);\n  margin-bottom: 28px;\n}\n\n.split-section img,\n.trust-box img {\n  border-radius: 8px;\n  object-fit: cover;\n  width: 100%;\n}\n\n.photo-stack-section {\n  padding-top: 34px;\n}\n\n.photo-stack-grid {\n  display: grid;\n  gap: 18px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-top: 28px;\n}\n\n.photo-stack-card {\n  align-items: flex-start;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--ink);\n  display: flex;\n  flex-direction: column;\n  min-height: 330px;\n  overflow: hidden;\n  padding: 14px;\n  position: relative;\n  text-align: left;\n}\n\n.photo-stack-card:hover {\n  background: var(--red);\n  border-color: rgba(235, 40, 63, 0.36);\n  box-shadow: var(--shadow);\n  color: #ffffff;\n  transform: translateY(-4px);\n}\n\n.photo-stack-card:hover strong,\n.photo-stack-card:hover small {\n  color: #ffffff;\n}\n\n.photo-stack-card:hover .stack-icon {\n  background: #ffffff;\n  color: var(--red);\n}\n\n.stack-icon {\n  align-items: center;\n  background: var(--red);\n  border-radius: 8px;\n  color: #ffffff;\n  display: flex;\n  height: 44px;\n  justify-content: center;\n  left: 24px;\n  position: absolute;\n  top: 24px;\n  width: 44px;\n  z-index: 2;\n}\n\n.stack-icon .icon {\n  height: 22px;\n  width: 22px;\n}\n\n.stack-images {\n  display: block;\n  height: 184px;\n  margin-bottom: 18px;\n  position: relative;\n  width: 100%;\n}\n\n.stack-images img {\n  border-radius: 8px;\n  height: 150px;\n  object-fit: cover;\n  position: absolute;\n  width: 82%;\n}\n\n.stack-images img:first-child {\n  left: 0;\n  top: 28px;\n  z-index: 3;\n}\n\n.stack-images img:nth-child(2) {\n  left: 10%;\n  top: 14px;\n  transform: rotate(4deg);\n  z-index: 2;\n}\n\n.stack-images img:nth-child(3) {\n  left: 18%;\n  top: 0;\n  transform: rotate(8deg);\n  z-index: 1;\n}\n\n.photo-stack-card strong {\n  color: var(--navy);\n  display: block;\n  font-size: 20px;\n  line-height: 1.2;\n  margin-bottom: 8px;\n}\n\n.photo-stack-card small {\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.photo-modal {\n  background: #ffffff;\n  border-radius: 8px;\n  max-height: calc(100vh - 40px);\n  max-width: 1060px;\n  overflow: auto;\n  padding: 24px;\n  position: relative;\n  width: 100%;\n}\n\n.photo-modal__head {\n  align-items: flex-start;\n  display: flex;\n  gap: 16px;\n  margin-bottom: 18px;\n  padding-right: 86px;\n}\n\n.photo-gallery {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.photo-gallery figure {\n  margin: 0;\n}\n\n.photo-gallery img {\n  aspect-ratio: 4 / 3;\n  border-radius: 8px;\n  object-fit: cover;\n  width: 100%;\n}\n\n.service-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-top: 24px;\n}\n\n.service-grid div {\n  align-items: flex-start;\n  background: var(--navy);\n  border-radius: 8px;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  font-weight: 800;\n  min-height: 86px;\n  padding: 18px;\n  transition: background-color 0.18s ease, transform 0.18s ease;\n}\n\n.service-grid div:hover {\n  background: #183b7a;\n  transform: translateY(-3px);\n}\n\n.service-grid .icon {\n  animation: serviceIconFloat 2.4s ease-in-out infinite;\n  color: #ffffff;\n  height: 42px;\n  width: 42px;\n}\n\n.service-grid div:nth-child(2n) .icon {\n  animation-delay: 0.25s;\n}\n\n.service-grid div:nth-child(3n) .icon {\n  animation-delay: 0.45s;\n}\n\n.cta-strip {\n  align-items: center;\n  background: var(--navy-dark);\n  border-radius: 8px;\n  color: #ffffff;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  margin-top: 22px;\n  padding: 24px;\n}\n\n.cta-strip h3,\n.cta-strip p {\n  color: #ffffff;\n  margin-bottom: 0;\n}\n\n.cta-strip p {\n  opacity: 0.82;\n}\n\n.review-photo {\n  aspect-ratio: 1;\n  border: 4px solid #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(17, 45, 99, 0.16);\n  height: 88px;\n  margin-bottom: 0;\n  object-fit: cover;\n  width: 88px;\n}\n\n.review-card strong,\n.review-card span {\n  display: block;\n}\n\n.review-card span {\n  color: var(--muted);\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.review-card p {\n  font-size: 15px;\n  position: relative;\n  z-index: 1;\n}\n\n.review-badge {\n  align-items: center;\n  background: rgba(235, 40, 63, 0.09);\n  border: 1px solid rgba(235, 40, 63, 0.16);\n  border-radius: 8px;\n  color: var(--red);\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 900;\n  gap: 7px;\n  margin-top: 20px;\n  padding: 8px 10px;\n  position: relative;\n  z-index: 1;\n}\n\n.review-badge .icon {\n  height: 14px;\n  width: 14px;\n}\n\n.contact-section {\n  background: var(--soft);\n  max-width: none;\n  padding-left: max(20px, calc((100vw - 1180px) / 2));\n  padding-right: max(20px, calc((100vw - 1180px) / 2));\n}\n\n.contact-grid {\n  display: grid;\n  gap: 22px;\n  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.72fr);\n}\n\n.trust-box {\n  background: var(--navy-dark);\n  border-radius: 8px;\n  color: #ffffff;\n  padding: 22px;\n}\n\n.trust-box h3 {\n  color: #ffffff;\n  margin-top: 18px;\n}\n\n.trust-box li,\n.trust-box p {\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.site-footer {\n  background:\n    linear-gradient(135deg, rgba(6, 17, 38, 0.94), rgba(17, 45, 99, 0.88)),\n    url(\"./images/fronthomeimage.jpeg\") center / cover;\n  color: #ffffff;\n  max-width: none;\n  padding-left: max(20px, calc((100vw - 1180px) / 2));\n  padding-right: max(20px, calc((100vw - 1180px) / 2));\n}\n\n.footer-main {\n  display: grid;\n  gap: 30px;\n  grid-template-columns: 1.45fr repeat(3, minmax(0, 1fr));\n}\n\n.brand-lockup--footer img {\n  background: #ffffff;\n  border-radius: 8px;\n}\n\n.brand-lockup--footer strong,\n.footer-column h3,\n.footer-brand p,\n.footer-bottom p,\n.footer-bottom span {\n  color: #ffffff;\n}\n\n.brand-lockup--footer span,\n.footer-brand p,\n.footer-bottom p {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.footer-brand p {\n  margin: 18px 0;\n}\n\n.footer-socials {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.footer-socials a {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 8px;\n  color: #ffffff;\n  display: flex;\n  height: 42px;\n  justify-content: center;\n  transition: background-color 0.18s ease, transform 0.18s ease;\n  width: 42px;\n}\n\n.footer-socials a:hover {\n  background: var(--red);\n  transform: translateY(-2px);\n}\n\n.footer-column h3 {\n  font-size: 16px;\n  margin-bottom: 14px;\n}\n\n.footer-column ul {\n  display: grid;\n  gap: 10px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.footer-column a {\n  color: rgba(255, 255, 255, 0.72);\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.footer-column a:hover {\n  color: #ffffff;\n}\n\n.footer-contact a {\n  align-items: flex-start;\n  display: flex;\n  gap: 9px;\n}\n\n.footer-contact .icon {\n  color: var(--red);\n  height: 17px;\n  margin-top: 2px;\n  width: 17px;\n}\n\n.footer-map {\n  align-items: center;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), rgba(235, 40, 63, 0.1));\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 8px;\n  display: grid;\n  gap: 26px;\n  grid-template-columns: minmax(260px, 0.48fr) minmax(520px, 1.52fr);\n  margin-top: 42px;\n  padding: 22px;\n}\n\n.footer-map h3,\n.footer-map p {\n  color: #ffffff;\n}\n\n.footer-map p {\n  color: rgba(255, 255, 255, 0.72);\n  margin-bottom: 0;\n}\n\n.footer-map__text {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-qr {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 8px;\n  display: flex;\n  gap: 14px;\n  margin-top: 12px;\n  padding: 12px;\n}\n\n.footer-qr img {\n  background: #ffffff;\n  border-radius: 8px;\n  height: 104px;\n  object-fit: contain;\n  padding: 8px;\n  width: 104px;\n}\n\n.footer-qr strong,\n.footer-qr span {\n  display: block;\n}\n\n.footer-qr strong {\n  color: #ffffff;\n  font-size: 15px;\n}\n\n.footer-qr span {\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 13px;\n  line-height: 1.45;\n  margin-top: 4px;\n}\n\n.footer-map iframe {\n  border: 0;\n  border-radius: 8px;\n  box-shadow: 0 22px 54px rgba(0, 0, 0, 0.28);\n  height: 420px;\n  min-height: 420px;\n  width: 100%;\n}\n\n.footer-bottom {\n  align-items: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  margin-top: 34px;\n  padding-top: 22px;\n}\n\n.footer-bottom p {\n  margin-bottom: 0;\n  max-width: 780px;\n}\n\n.footer-bottom span {\n  flex: 0 0 auto;\n  font-weight: 800;\n}\n\n.floating-enquiry {\n  bottom: 22px;\n  box-shadow: var(--shadow);\n  position: fixed;\n  right: 22px;\n  z-index: 20;\n}\n\n.floating-enquiry .icon {\n  height: 16px;\n  width: 16px;\n}\n\n.modal-backdrop {\n  align-items: center;\n  background: rgba(6, 17, 38, 0.66);\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  padding: 20px;\n  position: fixed;\n  z-index: 40;\n}\n\n.modal {\n  background: #ffffff;\n  border-radius: 8px;\n  max-height: calc(100vh - 40px);\n  max-width: 650px;\n  overflow: auto;\n  padding: 24px;\n  position: relative;\n  width: 100%;\n}\n\n.modal-close {\n  background: var(--soft);\n  border-color: var(--line);\n  color: var(--navy);\n  min-height: 36px;\n  padding: 7px 10px;\n  position: absolute;\n  right: 16px;\n  top: 16px;\n}\n\n.modal-close--icon {\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  min-height: 40px;\n  padding: 0;\n  width: 40px;\n}\n\n.modal-close--icon span {\n  background: currentColor;\n  border-radius: 999px;\n  display: block;\n  height: 2px;\n  position: absolute;\n  width: 18px;\n}\n\n.modal-close--icon span:first-child {\n  transform: rotate(45deg);\n}\n\n.modal-close--icon span:last-child {\n  transform: rotate(-45deg);\n}\n\n.admin-login {\n  align-items: center;\n  background: var(--soft);\n  display: flex;\n  min-height: 100vh;\n  padding: 20px;\n}\n\n.login-card {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 0 auto;\n  max-width: 460px;\n  padding: 30px;\n  width: 100%;\n}\n\n.admin-shell {\n  margin: 0 auto;\n  max-width: 1440px;\n  padding: 0 20px 40px;\n}\n\n.admin-header {\n  align-items: center;\n  display: flex;\n  gap: 18px;\n  justify-content: space-between;\n  padding: 26px 0;\n}\n\n.admin-header h1 {\n  font-size: 42px;\n  margin-bottom: 8px;\n}\n\n.admin-header p {\n  margin-bottom: 0;\n}\n\n.summary-strip {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  margin-bottom: 18px;\n}\n\n.summary-strip div {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.summary-strip strong,\n.summary-strip span {\n  display: block;\n}\n\n.summary-strip strong {\n  font-size: 28px;\n}\n\n.summary-strip span {\n  color: var(--muted);\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.admin-filters {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1.6fr repeat(7, minmax(120px, 1fr));\n  margin-bottom: 18px;\n  padding: 16px;\n}\n\n.admin-filters button {\n  align-self: end;\n}\n\n.admin-grid {\n  align-items: start;\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(360px, 0.95fr) minmax(420px, 1.05fr);\n}\n\n.admin-list-panel,\n.lead-detail {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n\n.admin-table-section {\n  display: block;\n}\n\n.admin-shell label {\n  font-weight: 700;\n}\n\n.admin-shell h1,\n.admin-shell h2,\n.admin-shell h3,\n.list-head strong,\n.lead-cell strong {\n  font-weight: 800;\n}\n\n.list-head {\n  align-items: center;\n  border-bottom: 1px solid var(--line);\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n}\n\n.list-head span {\n  color: var(--muted);\n}\n\n.lead-table {\n  overflow-x: auto;\n}\n\n.lead-table__head,\n.lead-table__row {\n  align-items: center;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: minmax(170px, 1.2fr) minmax(220px, 1.35fr) minmax(100px, 0.6fr) minmax(96px, 0.55fr) minmax(130px, 0.8fr) 92px;\n  min-width: 920px;\n}\n\n.lead-table__head {\n  background: var(--soft);\n  border-bottom: 1px solid var(--line);\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 800;\n  padding: 12px 16px;\n  text-transform: uppercase;\n}\n\n.lead-entry {\n  background: #ffffff;\n  border-bottom: 1px solid var(--line);\n}\n\n.lead-entry--open {\n  background: #fbfcff;\n}\n\n.lead-table__row {\n  padding: 14px 16px;\n}\n\n.lead-cell {\n  min-width: 0;\n}\n\n.lead-cell strong,\n.lead-cell span {\n  display: block;\n}\n\n.lead-cell--lead span,\n.lead-cell--muted {\n  color: var(--muted);\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.lead-cell--contact {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.lead-cell--contact a,\n.lead-cell--contact span {\n  align-items: center;\n  color: var(--navy);\n  display: inline-flex;\n  font-size: 13px;\n  font-weight: 600;\n  gap: 6px;\n  overflow-wrap: anywhere;\n  text-decoration: none;\n}\n\n.lead-cell--contact a:hover {\n  color: var(--red);\n}\n\n.lead-cell--contact .icon {\n  color: currentColor;\n  height: 14px;\n  width: 14px;\n}\n\n.lead-cell--action {\n  justify-self: end;\n}\n\n.lead-cell--action button {\n  min-height: 36px;\n  padding: 8px 12px;\n}\n\n.lead-expanded {\n  border-top: 1px solid var(--line);\n  display: grid;\n  gap: 18px;\n  padding: 18px;\n}\n\n.lead-update-panel {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.lead-update-panel h3 {\n  font-size: 18px;\n  margin-bottom: 14px;\n}\n\n.lead-list {\n  display: flex;\n  flex-direction: column;\n  max-height: 780px;\n  overflow: auto;\n}\n\n.lead-row {\n  background: #ffffff;\n  border-bottom: 1px solid var(--line);\n  border-radius: 0;\n  color: var(--ink);\n}\n\n.lead-row:hover,\n.lead-row--active {\n  background: var(--soft);\n}\n\n.lead-row__main {\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  color: var(--ink);\n  display: grid;\n  gap: 10px;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  justify-items: start;\n  min-height: 0;\n  padding: 16px 16px 8px;\n  text-align: left;\n  width: 100%;\n}\n\n.lead-row__main:hover {\n  background: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  color: var(--ink);\n  transform: none;\n}\n\n.lead-row__identity {\n  min-width: 0;\n}\n\n.lead-row__identity strong,\n.lead-row__identity small {\n  display: block;\n}\n\n.lead-row__identity small {\n  color: var(--muted);\n  overflow-wrap: anywhere;\n  margin-top: 4px;\n}\n\n.lead-row__contacts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0 16px 16px;\n}\n\n.lead-row__contacts a,\n.lead-detail__contacts a {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--navy);\n  display: inline-flex;\n  font-size: 13px;\n  font-weight: 900;\n  gap: 6px;\n  min-height: 34px;\n  overflow-wrap: anywhere;\n  padding: 7px 9px;\n  text-decoration: none;\n}\n\n.lead-row__contacts a:hover,\n.lead-detail__contacts a:hover {\n  background: #fff5f7;\n  border-color: rgba(235, 40, 63, 0.28);\n  color: var(--red);\n}\n\n.lead-row__contacts .icon,\n.lead-detail__contacts .icon {\n  color: currentColor;\n  height: 14px;\n  width: 14px;\n}\n\n.pill,\n.priority {\n  border-radius: 8px;\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 900;\n  justify-content: center;\n  padding: 7px 10px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.pill--new,\n.pill--contacted,\n.priority--cold {\n  background: #e7ecf6;\n  color: var(--navy);\n}\n\n.pill--follow-up,\n.priority--warm {\n  background: var(--yellow);\n  color: #6f5700;\n}\n\n.pill--qualified,\n.pill--converted {\n  background: #e8f6ef;\n  color: #1f6a48;\n}\n\n.pill--not-interested,\n.priority--hot {\n  background: #fff0f2;\n  color: var(--red-dark);\n}\n\n.pill--closed {\n  background: #eceff4;\n  color: #4b5563;\n}\n\n.lead-detail {\n  padding: 22px;\n  position: sticky;\n  top: 86px;\n}\n\n.lead-detail__head {\n  border-bottom: 1px solid var(--line);\n  margin-bottom: 18px;\n  padding-bottom: 18px;\n}\n\n.lead-detail__head h2 {\n  margin: 12px 0 6px;\n}\n\n.lead-detail__contacts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.lead-meta {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin: 0 0 18px;\n}\n\n.lead-meta div,\n.query-box {\n  background: var(--soft);\n  border-radius: 8px;\n  padding: 14px;\n}\n\n.lead-meta dt {\n  color: var(--muted);\n  font-size: 12px;\n  font-weight: 900;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n\n.lead-meta dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.query-box {\n  margin-bottom: 18px;\n}\n\n.query-box p {\n  margin: 8px 0 0;\n}\n\n.admin-update {\n  border-bottom: 1px solid var(--line);\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-bottom: 18px;\n  padding-bottom: 18px;\n}\n\n.admin-update label:nth-last-of-type(1),\n.admin-update button {\n  grid-column: 1 / -1;\n}\n\n.timeline h3 {\n  margin-bottom: 12px;\n}\n\n.timeline-item {\n  border-left: 3px solid var(--red);\n  padding: 0 0 18px 14px;\n}\n\n.timeline-item strong,\n.timeline-item span {\n  display: block;\n}\n\n.timeline-item span {\n  color: var(--muted);\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.timeline-item p {\n  margin: 8px 0 0;\n}\n\n.empty-state {\n  color: var(--muted);\n  padding: 24px;\n}\n\n@media (max-width: 1180px) {\n  .header-main {\n    align-items: center;\n    grid-template-columns: 1fr auto;\n    padding-bottom: 14px;\n  }\n\n  .menu-toggle {\n    align-items: center;\n    background: var(--navy);\n    border-color: var(--navy);\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    height: 42px;\n    min-height: 40px;\n    padding: 0;\n    width: 46px;\n  }\n\n  .menu-toggle span {\n    background: #ffffff;\n    border-radius: 999px;\n    display: block;\n    height: 2px;\n    transition: transform 0.18s ease, opacity 0.18s ease;\n    width: 20px;\n  }\n\n  .site-header--open .menu-toggle span:first-child {\n    transform: translateY(7px) rotate(45deg);\n  }\n\n  .site-header--open .menu-toggle span:nth-child(2) {\n    opacity: 0;\n  }\n\n  .site-header--open .menu-toggle span:last-child {\n    transform: translateY(-7px) rotate(-45deg);\n  }\n\n  .nav-links,\n  .header-actions {\n    display: none;\n    grid-column: 1 / -1;\n    grid-row: auto;\n  }\n\n  .nav-links {\n    border-radius: 8px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 10px;\n  }\n\n  .header-actions {\n    justify-content: stretch;\n  }\n\n  .site-header--open .nav-links,\n  .site-header--open .header-actions {\n    align-items: stretch;\n    animation: menuDrop 0.18s ease both;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .site-header--open .nav-links button,\n  .site-header--open .header-actions button,\n  .site-header--open .header-actions .button {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .site-header--open .language-switch {\n    width: 100%;\n  }\n\n  .site-header--open .language-switch__option {\n    flex: 1;\n    width: auto;\n  }\n\n  .site-header--open .header-actions {\n    background: #ffffff;\n    border: 1px solid var(--line);\n    border-radius: 8px;\n    padding: 10px;\n  }\n\n  .hero,\n  .split-section,\n  .documents-card,\n  .contact-grid,\n  .admin-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .lead-detail {\n    position: static;\n  }\n\n  .admin-filters {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .footer-main {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-brand {\n    grid-column: 1 / -1;\n  }\n\n  .photo-stack-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 860px) {\n  h1 {\n    font-size: 40px;\n  }\n\n  h2 {\n    font-size: 30px;\n  }\n\n  .hero {\n    padding-top: 34px;\n  }\n\n  .documents-card {\n    padding: 18px;\n  }\n\n  .document-visual {\n    min-height: 330px;\n    padding: 18px;\n  }\n\n  .document-visual svg {\n    max-width: 280px;\n  }\n\n  .form-grid,\n  .info-grid,\n  .info-grid--four,\n  .document-list,\n  .college-grid,\n  .college-card,\n  .review-grid,\n  .faq-grid,\n  .step-grid,\n  .service-grid,\n  .summary-strip,\n  .admin-filters,\n  .lead-meta,\n  .admin-update {\n    grid-template-columns: 1fr;\n  }\n\n  .college-card .college-card__content,\n  .college-card:nth-child(even) .college-card__content {\n    order: 2;\n  }\n\n  .college-card__photo,\n  .college-card:nth-child(even) .college-card__photo {\n    order: 1;\n  }\n\n  .trust-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .photo-stack-grid,\n  .photo-gallery {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .review-grid {\n    grid-auto-columns: minmax(280px, 82vw);\n    grid-template-columns: none;\n  }\n\n  .service-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .service-grid div {\n    min-height: 118px;\n    padding: 14px;\n  }\n\n  .service-grid span {\n    font-size: 13px;\n    line-height: 1.35;\n  }\n\n  .service-grid .icon {\n    height: 36px;\n    width: 36px;\n  }\n\n  .lead-table {\n    overflow-x: visible;\n  }\n\n  .lead-table__head {\n    display: none;\n  }\n\n  .lead-table__row {\n    align-items: stretch;\n    gap: 12px;\n    grid-template-columns: 1fr;\n    min-width: 0;\n    padding: 14px;\n  }\n\n  .lead-cell--contact {\n    background: var(--soft);\n    border-radius: 8px;\n    padding: 10px;\n  }\n\n  .lead-cell--action {\n    justify-self: stretch;\n  }\n\n  .lead-cell--action button {\n    width: 100%;\n  }\n\n  .lead-expanded {\n    padding: 14px;\n  }\n\n  .cta-strip,\n  .footer-bottom,\n  .admin-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .footer-main {\n    gap: 22px 16px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-brand,\n  .footer-contact {\n    grid-column: 1 / -1;\n  }\n\n  .footer-column h3 {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n\n  .footer-column a {\n    font-size: 13px;\n    line-height: 1.35;\n  }\n\n  .footer-column ul {\n    gap: 8px;\n  }\n\n  .footer-bottom {\n    align-items: flex-start;\n  }\n\n  .footer-map {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .site-header,\n  .hero,\n  .section-band,\n  .services-section,\n  .contact-section,\n  .site-footer,\n  .admin-shell {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .header-actions,\n  .header-actions .button,\n  .header-actions button,\n  .language-switch,\n  .hero-actions,\n  .hero-actions .button,\n  .hero-actions button,\n  .admin-header__actions,\n  .admin-header__actions button {\n    width: 100%;\n  }\n\n  .brand-lockup strong {\n    font-size: 19px;\n  }\n\n  .brand-lockup span {\n    font-size: 13px;\n  }\n\n  h1 {\n    font-size: 34px;\n  }\n\n  .lead-form,\n  .modal,\n  .photo-modal,\n  .trust-box,\n  .login-card,\n  .lead-detail {\n    padding: 18px;\n  }\n\n  .photo-stack-grid {\n    gap: 12px;\n  }\n\n  .photo-stack-card {\n    min-height: 268px;\n    padding: 10px;\n  }\n\n  .stack-images {\n    height: 138px;\n  }\n\n  .stack-images img {\n    height: 112px;\n  }\n\n  .stack-icon {\n    height: 34px;\n    left: 16px;\n    top: 16px;\n    width: 34px;\n  }\n\n  .stack-icon .icon {\n    height: 17px;\n    width: 17px;\n  }\n\n  .photo-stack-card strong {\n    font-size: 15px;\n  }\n\n  .photo-stack-card small {\n    font-size: 12px;\n  }\n\n  .photo-gallery {\n    grid-template-columns: 1fr;\n  }\n\n  .floating-enquiry {\n    bottom: 14px;\n    right: 14px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
